<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>


        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Analytical Dashboard</v-toolbar-title>
                <v-divider color="white" class="mx-4" inset vertical></v-divider>
                <v-toolbar-title>{{ selectedModule }}</v-toolbar-title>
            </v-toolbar>
            <v-row>
    <div class="tabs-outer">
       <div class="tabs-sticky-wrapper">
         <div class="tabs-bg sticky-tabs">
           <div class="pill-wrapper">
              <v-btn
                v-for="tab in moduleTabs"
                :key="tab"
                class="custom-tabs"
                :class="{ active: selectedModule === tab }"
                :ripple="false"
                text
                @click="selectedModule = tab" >
              {{ tab }}
           </v-btn>
         </div>
       </div>
      </div>
    </div>

                <v-col v-if="selectedModule" cols="11" sm="11" md="11">
                    <div v-if="selectedModule === 'Appraisal'" class="pa-6">
        <!-- Filter: Academic Year (optional – can be single or multi-year) -->
        <v-row justify="center" class="mb-6">
            <v-col cols="12" sm="6" md="4">
                <v-autocomplete v-model="selectedAppraisalAY" :items="ayList" item-text="ay" item-value="id"
                    label="Select Academic Year" outlined dense rounded prepend-inner-icon="mdi-calendar"
                    :loading="appraisalLoading" @change="fetchAppraisalData"></v-autocomplete>
            </v-col>
            <!-- <v-col cols="auto" class="d-flex align-center">
                <v-btn color="indigo darken-2" dark :loading="appraisalLoading" @click="fetchAppraisalData">
                    Refresh
                </v-btn>
            </v-col> -->
        </v-row>

        <!-- Graph – Always show container -->
        <v-card class="chart-card pa-6" elevation="4" v-if="appraisalScores.length || appraisalLoading">
            <!-- <v-card-title class="text-h6 font-weight-bold justify-center">
                Appraisal Score 
            </v-card-title> -->

            <div class="d-flex justify-center align-center" style="min-height: 420px;">
                <chart :options="appraisalScoreChart" autoresize style="width: 100%; max-width: 950px; height: 520px;">
                </chart>
            </div>

            <!-- Loading / No data states -->
            <div v-if="appraisalLoading" class="text-center py-8">
                <v-progress-circular indeterminate color="indigo"></v-progress-circular>
                <p class="mt-4">Loading appraisal scores...</p>
            </div>
            <div v-else-if="!appraisalScores.length" class="text-center py-12 grey--text text--darken-1">
                <v-icon size="80" color="grey lighten-1">mdi-chart-bar</v-icon>
                <p class="mt-6">No appraisal data available for selected year(s)</p>
            </div>
        </v-card>
    </div>
                    <div v-if="selectedModule == 'Profile'">
                        <v-row class="d-flex justify-center mr-10">
                            <!-- Publication Button with Active State -->
                            <v-btn outlined class="mx-2 profile-btn" color="success"
                                :class="{ 'active-button': activeTab === 'Publication' }"
                                @click="setActiveTab('Publication')">
                                Publication
                            </v-btn>

                            <v-btn outlined class="mx-2 profile-btn" color="success"
                                :class="{ 'active-button': activeTab === 'Training' }"
                                @click="setActiveTab('Training')">
                                Training
                            </v-btn>

                            <v-btn outlined class="mx-2 profile-btn" color="success"
                                :class="{ 'active-button': activeTab === 'Activity' }"
                                @click="setActiveTab('Activity')">
                                Activity
                            </v-btn>
                        </v-row>

                        <!-- Conditionally Render Based on Active Tab -->
                        <div>
                            <div v-if="activeTab === 'Publication'">
                                <br>
                                <br>
                                <v-row justify="center">
                                    <v-col align="right" cols="12" sm="3" md="3">
                                        <v-btn v-model="profile_overall" @click="getInstructoPublicationAnalytics"
                                            :loading="loading3" color="brand" style="color: white" elevated><v-icon
                                                left>mdi-chart-bar</v-icon>Overall</v-btn>
                                    </v-col>
                                    <v-col class="mr-7" cols="12" sm="3" md="3">
                                        <v-btn @click="showFilters_profile" color="brand" style="color: white"
                                            elevated><v-icon left>mdi-filter</v-icon>Filters</v-btn>
                                    </v-col>
                                </v-row>
                                <br />
                                <div v-if="profile_overall" class="cols-9 align-center d-flex flex-row mt-4">
                                    <chart
                                        style="width: 800px; height: 400px; border: 1px solid grey; margin-left: 75px;"
                                        auto-resize :options="publication_option"></chart>
                                    <div class="squares2 ml-10"
                                        style="background-color: hotpink; border: 4px solid rgb(243, 180, 211);">
                                        <b>Total <br> Publications #</b> <b> {{ totalPublications }} </b>
                                    </div>
                                </div>
                                <div v-if="profile_filtered_publications">
                                    <div class="row justify-center mr-8">
                                        <v-radio-group v-model="publicaton_radios" mandatory row
                                            class="ma-2 no-display">
                                            <v-radio label="By Academic Year" value="academic_year"
                                                color="#0f2027"></v-radio>
                                            <v-radio label="Do You Want Date Range?" value="date_range"
                                                color="#0f2027"></v-radio>

                                        </v-radio-group>
                                    </div>
                                    <div v-if="publicaton_radios == 'academic_year'">
                                        <v-row justify="center">

                                            <v-col cols="12" sm="3">
                                                <v-icon color="error">*</v-icon>
                                                <v-autocomplete color="#0F2027" dense rounded required
                                                    v-model="ay_other" :items="ay_list_other" item-text="ay"
                                                    item-value="id" label="Academic Year" outlined persistent-hint
                                                    hint="Please Select AY" />
                                            </v-col>
                                            <v-col cols="12" sm="2" style="margin-top: 28px;">

                                                <v-btn color="indigo darken-4" style="color: white;"
                                                    v-model="getInstructoPublicationAnalyticsByAy_fetch"
                                                    :loading="loader3"
                                                    @click="getInstructoPublicationAnalyticsByAy">Apply</v-btn>
                                            </v-col>
                                        </v-row>
                                        <div class="cols-9 align-center d-flex flex-row mt-10"
                                            v-if="getInstructoPublicationAnalyticsByAy_fetch">
                                            <chart
                                                style="width: 800px; height: 390px; border: 1px solid grey;margin-left: 75px;"
                                                auto-resize :options="publication_by_ay_option">
                                            </chart>
                                            <div class="squares2 ml-10"
                                                style="background-color: hotpink; border: 4px solid rgb(243, 180, 211);">
                                                <b>Total <br> Publications #</b> <b> {{ totalPublicationsByAy }} </b>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="publicaton_radios == 'date_range'">
                                        <v-row justify="center">


                                            <v-col cols="12" sm="3">
                                                <!-- <p><v-icon color="error">*</v-icon><b>From Date</b></p> -->
                                                <v-text-field outlined dense type="date" v-model="fromdate"
                                                    label="From Date" hint="From Date"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3">
                                                <!-- <p><v-icon color="error">*</v-icon><b>To Date</b></p> -->
                                                <v-text-field outlined dense type="date" v-model="todate"
                                                    label="To Date" hint="To Date"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2">

                                                <v-btn color="indigo darken-3" style="color: white;"
                                                    v-model="getInstructoPublicationAnalyticsByAy_fetch_2"
                                                    :loading="loader3"
                                                    @click="getInstructoPublicationAnalyticsByAy">Apply</v-btn>
                                            </v-col>
                                        </v-row>
                                        <div class="cols-9 align-center d-flex flex-row mt-10"
                                            v-if="getInstructoPublicationAnalyticsByAy_fetch_2">
                                            <chart
                                                style="width: 800px; height: 390px; border: 1px solid grey;margin-left: 75px;"
                                                auto-resize :options="publication_by_ay_option">
                                            </chart>
                                            <div class="squares2 ml-10"
                                                style="background-color: hotpink; border: 4px solid rgb(243, 180, 211);">
                                                <b>Total <br> Publications #</b> <b> {{ totalPublicationsByAy }} </b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="activeTab === 'Training'">
                                <br>
                                <br>
                                <v-row justify="center">
                                    <v-col align="right" cols="12" sm="3" md="3">
                                        <v-btn v-model="profile_overall_2" @click="getInstructoTrainingAnalytics"
                                            :loading="loading3" color="brand" elevated style="color: white"><v-icon
                                                left>mdi-chart-bar</v-icon>Overall</v-btn>
                                    </v-col>
                                    <v-col class="mr-7" cols="12" sm="3" md="3">
                                        <v-btn @click="showFilters_profile" color="brand" style="color: white"
                                            elevated><v-icon left>mdi-filter</v-icon>Filters</v-btn>
                                    </v-col>
                                    <!-- <v-spacer></v-spacer> -->
                                    <!-- <v-col align="right" cols="3"><v-btn rounded  color="success" outlined ><v-icon color="success">mdi-export</v-icon>Export</v-btn ></v-col> -->
                                </v-row>
                                <br />
                                <div v-if="profile_overall_2" class="cols-9 align-center d-flex flex-row mt-4">
                                    <chart
                                        style="width: 800px; height: 400px; border: 1px solid grey; margin-left: 75px;"
                                        auto-resize :options="training_option"></chart>
                                    <div class="squares2 ml-10"
                                        style="background-color: hotpink; border: 4px solid rgb(243, 180, 211);">
                                        <b>Total Trainings #</b> <b> {{ totalTrainings }} </b>
                                    </div>
                                </div>
                                <div v-if="profile_filtered_trainings">
                                    <div class="row justify-center mr-8">
                                        <v-radio-group v-model="training_radios" mandatory row class="ma-2 no-display">
                                            <v-radio label="By Academic Year" value="academic_year"
                                                color="#0f2027"></v-radio>
                                            <v-radio label="Do You Want Date Range?" value="date_range"
                                                color="#0f2027"></v-radio>

                                        </v-radio-group>
                                    </div>
                                    <div v-if="training_radios == 'academic_year'">
                                        <v-row justify="center">

                                            <v-col cols="12" sm="3">
                                                <v-icon color="error">*</v-icon>
                                                <v-autocomplete color="#0F2027" dense rounded required
                                                    v-model="ay_is_inerp" :items="ay_list_is_inerp" item-text="ay"
                                                    item-value="id" label="Academic Year" outlined persistent-hint
                                                    hint="Please Select AY" />
                                            </v-col>
                                            <v-col cols="12" sm="2" style="margin-top: 28px;">

                                                <v-btn color="indigo darken-4" style="color: white;"
                                                    v-model="getInstructoTrainingAnalyticsByAy_fetch" :loading="loader3"
                                                    @click="getInstructoTrainingAnalyticsByAy">Apply</v-btn>
                                            </v-col>
                                        </v-row>
                                        <div class="cols-9 align-center d-flex flex-row mt-10"
                                            v-if="getInstructoTrainingAnalyticsByAy_fetch">
                                            <chart
                                                style="width: 800px; height: 390px; border: 1px solid grey;margin-left: 75px;"
                                                auto-resize :options="training_by_ay_option">
                                            </chart>
                                            <div class="squares2 ml-10"
                                                style="background-color: hotpink; border: 4px solid rgb(243, 180, 211);">
                                                <b>Total Trainings #</b> <b> {{ totalTrainingsByAy }} </b>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="training_radios == 'date_range'">
                                        <v-row class="justify-center">


                                            <v-col cols="12" sm="3">
                                                <!-- <p><v-icon color="error">*</v-icon><b>From Date</b></p> -->
                                                <v-text-field outlined dense type="date" v-model="fromdate"
                                                    label="From Date" hint="From Date"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3">
                                                <!-- <p><v-icon color="error">*</v-icon><b>To Date</b></p> -->
                                                <v-text-field outlined dense type="date" v-model="todate"
                                                    label="To Date" hint="To Date"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2">

                                                <v-btn color="indigo darken-3" style="color: white;"
                                                    v-model="getInstructoTrainingAnalyticsByAy_fetch" :loading="loader3"
                                                    @click="getInstructoTrainingAnalyticsByAy">Apply</v-btn>
                                            </v-col>
                                        </v-row>
                                        <div class="cols-9 align-center d-flex flex-row mt-10"
                                            v-if="getInstructoTrainingAnalyticsByAy_fetch_2">
                                            <chart
                                                style="width: 800px; height: 390px; border: 1px solid grey;margin-left: 75px;"
                                                auto-resize :options="training_by_ay_option">
                                            </chart>
                                            <div class="squares2 ml-10"
                                                style="background-color: hotpink; border: 4px solid rgb(243, 180, 211);">
                                                <b>Total Trainings #</b> <b> {{ totalTrainingsByAy }} </b>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div v-if="activeTab === 'Activity'">
                                <br>
                                <br>
                                <v-row justify="center">
                                    <v-col align="right" cols="12" sm="3" md="3">
                                        <v-btn v-model="profile_overall_3" @click="getInstructoActivityAnalytics"
                                            :loading="loading3" color="brand" elevated style="color: white"><v-icon
                                                left>mdi-chart-bar</v-icon>Overall</v-btn>
                                    </v-col>
                                    <v-col class="mr-7" cols="12" sm="3" md="3">
                                        <v-btn @click="showFilters_profile" color="brand" style="color: white"
                                            elevated><v-icon left>mdi-filter</v-icon>Filters</v-btn>
                                    </v-col>
                                    <!-- <v-spacer></v-spacer> -->
                                    <!-- <v-col align="right" cols="3"><v-btn rounded  color="success" outlined ><v-icon color="success">mdi-export</v-icon>Export</v-btn ></v-col> -->
                                </v-row>
                                <br />
                                <div v-if="profile_overall_3" class="cols-9 align-center d-flex flex-row mt-4">
                                    <chart
                                        style="width: 800px; height: 400px; border: 1px solid grey; margin-left: 75px;"
                                        auto-resize :options="activities_option"></chart>
                                    <div class="squares2 ml-10"
                                        style="background-color: hotpink; border: 4px solid rgb(243, 180, 211);">
                                        <b>Total Activities #</b> <b> {{ totalActivities }} </b>
                                    </div>
                                </div>
                                <div v-if="profile_filtered_activities">
                                    <div class="row justify-center">
                                        <v-radio-group v-model="activities_radios" mandatory row
                                            class="ma-2 no-display">
                                            <v-radio label="By Academic Year" value="academic_year"
                                                color="#0f2027"></v-radio>
                                            <v-radio label="Do You Want Date Range?" value="date_range"
                                                color="#0f2027"></v-radio>

                                        </v-radio-group>
                                    </div>
                                    <div v-if="activities_radios == 'academic_year'">
                                        <v-row justify="center">

                                            <v-col cols=" 12" sm="3">
                                                <v-icon color="error">*</v-icon>
                                                <v-autocomplete color="#0F2027" dense rounded required
                                                    v-model="ay_activities" :items="ay_list_other" item-text="ay"
                                                    item-value="id" label="Academic Year" outlined persistent-hint
                                                    hint="Please Select AY" />
                                            </v-col>
                                            <v-col cols="12" sm="2" style="margin-top: 28px;">

                                                <v-btn color="indigo darken-3" style="color: white;"
                                                    v-model="getInstructoTActivityAnalyticsByAy_fetch"
                                                    :loading="loader3"
                                                    @click="getInstructoTActivityAnalyticsByAy">Apply</v-btn>
                                            </v-col>
                                        </v-row>
                                        <div class="cols-9 align-center d-flex flex-row mt-10"
                                            v-if="getInstructoTActivityAnalyticsByAy_fetch">
                                            <chart
                                                style="width: 800px; height: 390px; border: 1px solid grey;margin-left: 75px;"
                                                auto-resize :options="activities_by_ay_option">
                                            </chart>
                                            <div class="squares2 ml-10"
                                                style="background-color: hotpink; border: 4px solid rgb(243, 180, 211);">
                                                <b>Total Activities #</b> <b> {{ totalActivitiesByAy }} </b>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="activities_radios == 'date_range'">
                                        <v-row justify="center">


                                            <v-col cols="12" sm="3">
                                                <!-- <p><v-icon color="error">*</v-icon><b>From Date</b></p> -->
                                                <v-text-field outlined dense type="date" v-model="fromdate"
                                                    label="From Date" hint="From Date"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3">
                                                <!-- <p><v-icon color="error">*</v-icon><b>To Date</b></p> -->
                                                <v-text-field outlined dense type="date" v-model="todate"
                                                    label="To Date" hint="To Date"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2">

                                                <v-btn color="indigo darken-3" style="color: white;"
                                                    v-model="getInstructoTActivityAnalyticsByAy_fetch_2"
                                                    :loading="loader3"
                                                    @click="getInstructoTActivityAnalyticsByAy">Apply</v-btn>
                                            </v-col>
                                        </v-row>
                                        <div class="cols-9 align-center d-flex flex-row mt-10"
                                            v-if="getInstructoTActivityAnalyticsByAy_fetch_2">
                                            <chart
                                                style="width: 800px; height: 390px; border: 1px solid grey;margin-left: 75px;"
                                                auto-resize :options="activities_by_ay_option">
                                            </chart>
                                            <div class="squares2 ml-10"
                                                style="background-color: hotpink; border: 4px solid rgb(243, 180, 211);">
                                                <b>Total Activities #</b> <b> {{ totalActivitiesByAy }} </b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div v-if="selectedModule === 'Feedback'">
                        <v-row justify="start" class="px-6 mb-4">
                            <v-col cols="auto">
                                <v-btn @click="activeFeedbackTab = 'overall'"
                                    :class="activeFeedbackTab === 'overall' ? 'active-btn' : 'inactive-btn'" text>
                                    <v-icon left>mdi-chart-bar</v-icon>
                                    OVERALL
                                </v-btn>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn @click="activeFeedbackTab = 'filter'"
                                    :class="activeFeedbackTab === 'filter' ? 'active-btn' : 'inactive-btn'" text>
                                    <v-icon left>mdi-filter</v-icon>
                                    FILTERS
                                </v-btn>
                            </v-col>
                        </v-row>

                        <div v-if="activeFeedbackTab === 'overall'" class="px-6">
                            <v-row>
                                <v-col cols="12" md="9">
                                    <v-card class="chart-card pa-4" elevation="4">
                                        <chart :options="overallFeedbackChart" autoresize
                                            style="width: 100%; height: 520px;"></chart>
                                    </v-card>
                                </v-col>

                                <v-col cols="12" md="3" class="d-flex align-center">
                                    <v-card class="avg-card pa-6" elevation="6">
                                        <div class="avg-title text-center">Overall Avg</div>
                                        <div class="avg-value text-center">{{ overallPerformanceAvg }}</div>
                                        <div class="avg-subtitle text-center">Performance Index</div>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>

                        <div v-if="activeFeedbackTab === 'filter'" class="px-6">
                            <v-card outlined class="pa-6 mb-6">
                                <v-row align="center">
                                    <v-col cols="12" sm="6" md="4">
                                        <v-autocomplete v-model="selectedFeedbackAY" :items="ayList" item-text="ay"
                                            item-value="ay" label="Select Academic Year" outlined dense rounded
                                            prepend-inner-icon="mdi-calendar" :loading="feedbackLoading"
                                            @change="updateFilteredChart"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn color="indigo darken-2" dark :loading="feedbackLoading"
                                            @click="fetchFeedbackPerformance">
                                            Refresh
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>

                            <v-card v-if="selectedFeedbackAY && filteredIndex !== null" class="chart-card pa-4"
                                elevation="4">
                                <chart :options="filteredFeedbackChart" autoresize style="width: 100%; height: 480px;">
                                </chart>
                            </v-card>

                            <v-card v-else class="text-center pa-12" flat>
                                <v-icon size="80" color="grey lighten-1">mdi-chart-bar</v-icon>
                                <p class="mt-6 grey--text text--darken-1">
                                    Select an Academic Year to view performance index
                                </p>
                            </v-card>
                        </div>
                    </div> -->
                    <div v-if="selectedModule == 'Biometric'">
    <v-row justify="start" class="px-6">

        <v-col cols="auto">
            <v-btn
                @click="selectSubTab('overall')"
                :class="activeSubTab === 'overall' ? 'active-btn' : 'inactive-btn'"
                text
            >
                <v-icon left>mdi-chart-bar</v-icon>
                Overall
            </v-btn>
        </v-col>

        <v-col cols="auto">
            <v-btn
                @click="selectSubTab('filters')"
                :class="activeSubTab === 'filters' ? 'active-btn' : 'inactive-btn'"
                text
            >
                <v-icon left>mdi-filter</v-icon>
                Filters
            </v-btn>
        </v-col>
    </v-row>
    
    <!-- OVERALL TAB -->
    <div v-if="overall" class="mt-4 px-4">
    <div class="d-flex flex-row align-center analytics-wrapper" style="width: 100%;">
        
        <chart 
            :options="option1" 
            autoresize
            style="width: 100%; height: 500px; border: 1px solid #e0e0e0; border-radius: 12px; padding: 10px; background-color: #ffffff;"
        ></chart>

        <div class="avg-hours-ui ml-8"> 
        <div class="avg-title">Overall Average Working Hours</div>
        <div class="avg-value">{{ totalAverageWorkingHours }}</div>
       </div>
    </div>
</div>
    <!-- Change v-if="filtered" to v-if="activeSubTab === 'filters'" -->
    <div v-if="activeSubTab === 'filters'">

  <!-- FILTER CARD -->
    <v-row align="center" no-gutters class="ma-0 mb-6">
      <v-col cols="12" sm="3" md="3" class="pa-0 pr-2">

        <v-icon color="error" small>*</v-icon>
        <v-autocomplete
          dense
          rounded
          outlined
          required
          v-model="ay_other"
          :items="ay_list_other"
          item-text="ay"
          item-value="id"
          label="Academic Year"
          persistent-hint
          hint="Please select Academic Year"
        />
      </v-col>

      <v-col cols="auto" class="pa-2">
        <v-btn
          color="brand"
          dark
          :loading="loader2"
          class="fetch-btn"
          @click="getInstructorAttendanceAnalyticsByAy"
        >
          Fetch
        </v-btn>
      </v-col>
    </v-row>

  <!-- CHART + SUMMARY -->
  <div
    v-if="getInstructorAttendanceAnalyticsByAy_fetch"
    class="d-flex flex-row align-center analytics-wrapper"
  >
    <!-- CHART -->
    <chart
  :options="option2"
  autoresize
  style="
    width: 100%;
    height: 420px;
    border: 1px solid #CBD5E1;
    border-radius: 12px;
    background-color: #ffffff;
  "
></chart>

    <!-- SUMMARY CARD -->
    <div class="avg-hours-ui ml-8"> 
    <div class="avg-title">Total Average Working Hours</div>
    <div class="avg-value">{{ totalAverageWorkingHours }}</div>
    </div>
   </div>
  </div>
</div>
                    <!-- <div v-if="selectedModule == 'Result'">
                        <div class="box">
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Subject Result Analysis</v-toolbar-title>
                                <v-divider color="white" class="mx-4" inset vertical></v-divider>
                            </v-toolbar>
                            <v-row justify="center">
                                <v-col cols="12" sm="3">
                                    <v-autocomplete color="#0F2027" dense rounded required @change="getInstCourse(std)"
                                        v-model="std" :items="std_list" item-text="std_name" return-object
                                        label="Standard" outlined persistent-hint hint="Please Select Standard" />
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-autocomplete color="#0F2027" dense rounded required v-model="semester"
                                        :items="semester_list" item-text="sem" item-value="id" label="Semester" outlined
                                        persistent-hint hint="Please Select Semester" />
                                </v-col>
                                <v-col cols="12" sm="3" v-if="course_list != ''">
                                    <v-autocomplete color="#0F2027" @change="getInst(course)" dense rounded required
                                        v-model="course" :items="course_list" item-text="coff_name" return-object
                                        label="Course" outlined persistent-hint hint="Please Select Course" />
                                </v-col>
                                <v-col cols="12" sm="3" v-if="inst_list != ''">
                                    <v-autocomplete color="#0F2027" dense rounded required v-model="inst"
                                        :items="inst_list" item-text="inst_name" return-object label="Employee" outlined
                                        persistent-hint hint="Please Select Employee" />
                                </v-col>
                                <v-row justify="center" v-if="inst">
                                    <v-btn color="info" :loading="loader" v-model="CourseDetails"
                                        @click="fetchCourseResultData()">Fetch</v-btn>
                                </v-row>
                            </v-row>
                        </div> -->
                        <div v-if="selectedModule == 'Result'">
    <div class="box">
        <v-toolbar flat dense class="toolbar">
            <v-toolbar-title>Subject Result Analysis</v-toolbar-title>
            <v-divider color="white" class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <v-row justify="center">
            <!-- Standard -->
            <v-col cols="12" sm="4" md="3">
                <v-autocomplete
                    color="#0F2027"
                    dense
                    rounded
                    required
                    @change="getInstCourse(std)"
                    v-model="std"
                    :items="std_list"
                    item-text="std_name"
                    return-object
                    label="Standard"
                    outlined
                    persistent-hint
                    hint="Please Select Standard"
                />
            </v-col>

            <!-- Semester -->
            <v-col cols="12" sm="4" md="3">
                <v-autocomplete
                    color="#0F2027"
                    dense
                    rounded
                    required
                    v-model="semester"
                    :items="semester_list"
                    item-text="sem"
                    item-value="id"
                    label="Semester"
                    outlined
                    persistent-hint
                    hint="Please Select Semester"
                />
            </v-col>

            <!-- Course -->
            <v-col cols="12" sm="4" md="4" v-if="course_list && course_list.length > 0">
                <v-autocomplete
                    color="#0F2027"
                    dense
                    rounded
                    required
                    @change="onCourseSelected"
                    v-model="course"
                    :items="course_list"
                    item-text="coff_name"
                    return-object
                    label="Course"
                    outlined
                    persistent-hint
                    hint="Please Select Course"
                />
            </v-col>

            <!-- Fetch Button -->
            <v-row justify="center" class="mt-4" v-if="course && semester">
                <v-col cols="auto">
                    <v-btn
                        color="info"
                        :loading="loader"
                        :disabled="!course || !semester"
                        @click="fetchCourseResultData"
                    >
                        Fetch Result Analytics
                    </v-btn>
                </v-col>
            </v-row>
        </v-row>
    </div>
                        <div v-if="CourseDetails">
                            <v-row justify="center" dense
                                v-if="result_bar_graph_details != '' || marks_bar_graph_details != '' || avg_ass_type_result_bar_graph_details != ''">
                                <center>
                                    <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                                        <v-radio label="Grade" value="grade" color="#0f2027"></v-radio>
                                        <v-radio label="Marks" value="marks" color="#0f2027"></v-radio>
                                        <v-radio label="Assesment Type" value="assesment_type"
                                            color="#0f2027"></v-radio>
                                        <v-radio label="Class-wise Avg Marks" value="class_avg"
                                            color="#0f2027"></v-radio>
                                        <v-radio label="Grade-wise Avg Marks" value="grade_avg_marks"
                                            color="#0f2027"></v-radio>
                                        <v-radio label="Class-wise % Passing" value="class_pass"
                                            color="#0f2027"></v-radio>
                                        <v-radio label="Grade-wise % Passing" value="grade_pass" 
                                        color="#0f2027"></v-radio>
                                        <v-radio label="Subjectwise Avg Marks" value="subject_avg" color="#0f2027"></v-radio>
                                        <v-radio label="Class Test Performance" value="class_test_perf" color="#0f2027"></v-radio>
                                        <v-radio label="Grade Distribution" value="grade_dist" color="#0f2027"></v-radio>
                                        <v-radio label="Result Analysis" value="cycle_analysis" color="#0f2027"></v-radio>
                                        <v-radio label="Genderwise Performance" value="gender_perf" color="#0f2027"></v-radio>
                                    </v-radio-group>
                                </center>
                            </v-row>


                            <div v-if="result_bar_graph_details != '' && radios == 'grade'"
                                class="cols-12 align-center d-flex flex-row mt-10">
                                <chart style="width: 900px; height: 400px; border: 1px solid grey;margin-left:45px;"
                                    auto-resize :options="option_result">
                                </chart>
                                <div class="squares2 ml-10"
                                    style="background-color: hotpink; border: 4px solid rgb(243, 180, 211);">
                                    <b>Total Students #</b> <b> {{ resultBarGraphSum }} </b>
                                </div>
                                <br />
                            </div>
                            <div v-if="marks_bar_graph_details != '' && radios == 'marks'">
                                <chart style="width: 900px; height: 500px; border: 1px solid grey;" auto-resize
                                    :options="option_marks_result"></chart><br />
                            </div>
                            <div v-if="avg_ass_type_result_bar_graph_details != '' && radios == 'assesment_type'">
                                <chart style="width: 900px; height: 500px; border: 1px solid grey;" auto-resize
                                    :options="option_avg_result"></chart><br />
                            </div>
                            <div v-if="radios === 'class_avg' && option_class_avg.xAxis.data.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);"
                                    auto-resize :options="option_class_avg">
                                </chart>

                                <!-- <div class="mt-6 d-flex gap-8">
                                    <div class="squares2" style="background-color: #e3f2fd; border: 4px solid #90caf9;">
                                        <b>Highest Performing Class</b><br>
                                        <span style="font-size: 18px; color: #1976d2;">{{ highestClass }}</span>
                                    </div>
                                    <div class="squares2" style="background-color: #ffebee; border: 4px solid #ef9a9a;">
                                        <b>Lowest Performing Class</b><br>
                                        <span style="font-size: 18px; color: #c62828;">{{ lowestClass }}</span>
                                    </div>
                                </div> -->
                            </div>

                            <!-- 5TH GRAPH: Grade-wise Average Marks -->
                            <div v-if="radios === 'grade_avg_marks' && option_grade_avg.xAxis.data.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);"
                                    auto-resize :options="option_grade_avg">
                                </chart>

                                <!-- <div class="mt-6 d-flex gap-8">
        <div class="squares2" style="background-color: #e8f0fe; border: 4px solid #4285f4;">
            <b>Highest Avg Grade</b><br>
            <span style="font-size: 18px; color: #1967d2;">{{ highestGrade }}</span>
        </div>
        <div class="squares2" style="background-color: #fce8e6; border: 4px solid #ea4335;">
            <b>Lowest Avg Grade</b><br>
            <span style="font-size: 18px; color: #c5228;">{{ lowestGrade }}</span>
        </div>
    </div> -->
                            </div>

                            <div v-if="radios === 'class_pass' && option_class_pass.xAxis.data.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);"
                                    auto-resize :options="option_class_pass">
                                </chart>

                                <!-- <div class="mt-6 d-flex gap-8">
                                    <div class="squares2" style="background-color: #e8f5e9; border: 4px solid #a5d6a7;">
                                        <b>Highest Passing Class</b><br>
                                        <span style="font-size: 18px; color: #2e7d32;">{{ highestPassClass }}</span>
                                    </div>
                                    <div class="squares2" style="background-color: #ffebee; border: 4px solid #ef9a9a;">
                                        <b>Lowest Passing Class</b><br>
                                        <span style="font-size: 18px; color: #c62828;">{{ lowestPassClass }}</span>
                                    </div>
                                </div> -->
                            </div>
                            <!-- 7TH GRAPH: Grade-wise % of Passing -->
<div v-if="radios === 'grade_pass' && option_grade_pass.xAxis.data.length > 0" class="d-flex flex-column align-center mt-10">
    <chart
        style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
        auto-resize
        :options="option_grade_pass">
    </chart>

    <!-- <div class="mt-6 d-flex gap-8 justify-center">
        <div class="squares2" style="background-color: #e8f5e9; border: 4px solid #a5d6a7;">
            <b>Highest Passing Grade</b><br>
            <span style="font-size: 18px; color: #2e7d32;">{{ highestGradePass }}</span>
        </div>
        <div class="squares2" style="background-color: #ffebee; border: 4px solid #ef9a9a;">
            <b>Lowest Passing Grade</b><br>
            <span style="font-size: 18px; color: #c62828;">{{ lowestGradePass }}</span>
        </div>
    </div> -->
</div>
<!-- 8TH GRAPH: Subjectwise Avg Marks -->
<div v-if="radios === 'subject_avg' && option_subject_avg.xAxis.data.length > 0" class="d-flex flex-column align-center mt-10">
    <chart
        style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
        auto-resize
        :options="option_subject_avg">
    </chart>

    <!-- <div class="mt-6 d-flex gap-8 justify-center">
        <div class="squares2" style="background-color: #e3f2fd; border: 4px solid #90caf9;">
            <b>Highest Avg Class</b><br>
            <span style="font-size: 18px; color: #1976d2;">{{ highestSubjectClass }}</span>
        </div>
        <div class="squares2" style="background-color: #ffebee; border: 4px solid #ef9a9a;">
            <b>Lowest Avg Class</b><br>
            <span style="font-size: 18px; color: #c62828;">{{ lowestSubjectClass }}</span>
        </div>
    </div> -->
</div>
<!--  Class Test - Grade-wise Performance -->
<div v-if="radios === 'class_test_perf' && option_class_test_performance.xAxis.data.length > 0" class="d-flex flex-column align-center mt-10">
    <chart
        style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
        auto-resize
        :options="option_class_test_performance">
    </chart>

    <div class="mt-6 d-flex gap-8 justify-center">
        <div class="squares2" style="background-color: #e3f2fd; border: 4px solid #90caf9;">
            <b>Best Performing Class (Class Test)</b><br>
            <span style="font-size: 18px; color: #1976d2;">{{ highestClassTest }}</span>
        </div>
        <div class="squares2" style="background-color: #ffebee; border: 4px solid #ef9a9a;">
            <b>Lowest Performing Class (Class Test)</b><br>
            <span style="font-size: 18px; color: #c62828;">{{ lowestClassTest }}</span>
        </div>
    </div>
</div>
<!-- Grade Distribution Pie Chart -->
<div v-if="radios === 'grade_dist' && option_grade_distribution.series[0].data.length > 0" class="d-flex flex-column align-center mt-10">
    <chart
        style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
        auto-resize
        :options="option_grade_distribution">
    </chart>

    <!-- <div class="mt-6 d-flex gap-8 justify-center">
        <div class="squares2" style="background-color: #e3f2fd; border: 4px solid #90caf9;">
            <b>Most Common Grade</b><br>
            <span style="font-size: 18px; color: #1976d2;">{{ mostCommonGrade }}</span>
        </div>
        <div class="squares2" style="background-color: #fff3e0; border: 4px solid #ffb74d;">
            <b>Total Students</b><br>
            <span style="font-size: 18px; color: #ef6c00;">{{ totalStudentsInDist }}</span>
        </div>
    </div> -->
</div>

<!-- RESULT ANALYSIS: Cycle Comparison -->
<div v-if="radios === 'cycle_analysis' && option_cycle_comparison.xAxis.data.length > 0" class="d-flex flex-column align-center mt-10">
    <chart
        style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
        auto-resize
        :options="option_cycle_comparison">
    </chart>

    <!-- <div class="mt-6 d-flex gap-8 justify-center">
        <div class="squares2" style="background-color: #e3f2fd; border: 4px solid #90caf9;">
            <b>Best Cycle Overall</b><br>
            <span style="font-size: 18px; color: #1976d2;">{{ bestCycle }}</span>
        </div>
        <div class="squares2" style="background-color: #fff3e0; border: 4px solid #ffb74d;">
            <b>Total Cycles</b><br>
            <span style="font-size: 18px; color: #ef6c00;">{{ totalCycles }}</span>
        </div>
    </div> -->
</div>
<!-- GENDERWISE PERFORMANCE GRAPH -->
<div v-if="radios === 'gender_perf' && option_gender_performance.xAxis.data.length > 0" class="d-flex flex-column align-center mt-10">
    <chart
        style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
        auto-resize
        :options="option_gender_performance">
    </chart>

    <!-- <div class="mt-6 d-flex gap-8 justify-center">
        <div class="squares2" style="background-color: #e3f2fd; border: 4px solid #90caf9;">
            <b>Overall Best</b><br>
            <span style="font-size: 18px; color: #1976d2;">{{ overallBestGender }}</span>
        </div>
        <div class="squares2" style="background-color: #ffebee; border: 4px solid #ef9a9a;">
            <b>Biggest Gap</b><br>
            <span style="font-size: 18px; color: #c62828;">{{ biggestGapGrade }}</span>
        </div>
    </div> -->
</div>
                        </div>
                    </div>
                    <div v-if="selectedModule == 'Quiz'">
                        <v-row justify="center">
                            <v-col align="right" cols="3">
                                <v-btn v-model="overall" @click="getInstQuizData" :loading="loading4" color="brand"
                                    elevated style="color: white"><v-icon left>mdi-chart-bar</v-icon>Overall</v-btn>
                            </v-col>
                            <v-col align="left" cols="3">
                                <v-btn v-model="filtered" @click="showFilters" color="brand" style="color: white"
                                    elevated><v-icon left>mdi-filter</v-icon>Filters</v-btn>
                            </v-col>
                        </v-row>
                        <br>
                        <div v-if="overall && this.quiz_data != ''">
                            <chart style="width: 800px; height: 400px; border: 1px solid grey; margin-left: 100px;"
                                auto-resize :options="quiz_overall"></chart>
                        </div>
                        <div v-if="filtered" class="box">
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Coursewise Quiz Analysis</v-toolbar-title>
                                <v-divider color="white" class="mx-4" inset vertical></v-divider>
                            </v-toolbar>
                            <v-row justify="center">
                                <v-col cols="12" sm="3">
                                    <v-icon color="error">*</v-icon>
                                    <v-autocomplete color="#0F2027" dense rounded required @change="getInstCourse(std)"
                                        v-model="std" :items="std_list" item-text="std_name" return-object
                                        label="Standard" outlined persistent-hint hint="Please Select Standard" />
                                </v-col>
                                <!-- <v-col cols="12" sm="3">
                                <v-icon color="error">*</v-icon>
                                <v-autocomplete color="#0F2027" dense rounded required v-model="semester"
                                    :items="semester_list" item-text="sem" item-value="id" label="Semester" outlined
                                    persistent-hint hint="Please Select Semester" />
                            </v-col> -->
                                <v-col cols="12" sm="3" v-if="course_list != ''">
                                    <v-icon color="error">*</v-icon>
                                    <v-autocomplete color="#0F2027" @change="getInst(course)" dense rounded required
                                        v-model="course" :items="course_list" item-text="coff_name" return-object
                                        label="Course" outlined persistent-hint hint="Please Select Course" />
                                </v-col>
                                <v-col cols="12" sm="3" v-if="inst_list != ''">
                                    <v-icon color="error">*</v-icon>
                                    <v-autocomplete color="#0F2027" dense rounded required v-model="inst"
                                        :items="inst_list" item-text="inst_name" return-object label="Employee" outlined
                                        persistent-hint hint="Please Select Employee" />
                                </v-col>
                                <v-col cols="12" sm="3" align="left" style="align-content: center;" v-if="inst">
                                    <v-btn color="brand" :loading="loader" v-model="showGraph"
                                        @click="getInstQuizByAy()">Fetch</v-btn>
                                </v-col>
                            </v-row>
                        </div>
                        <br />
                        <div v-if="showGraph && this.quiz_data != ''">
                            <chart style="width: 800px; height: 400px; border: 1px solid grey; margin-left: 100px;"
                                auto-resize :options="quiz_byAy"></chart>
                        </div>
                    </div>
                    
    <div v-if="selectedModule == 'Homework'">
    <v-row justify="start" class="px-6">
        <v-col cols="auto">
            <v-btn
                @click="selectSubTab('overall')"
                :class="activeSubTab === 'overall' ? 'active-btn' : 'inactive-btn'"
                text
            >
                <v-icon left>mdi-chart-bar</v-icon>
                Overall
            </v-btn>
        </v-col>
        <v-col cols="auto">
            <v-btn
                @click="selectSubTab('filters')"
                :class="activeSubTab === 'filters' ? 'active-btn' : 'inactive-btn'"
                text
            >
                <v-icon left>mdi-filter</v-icon>
                Filters
            </v-btn>
        </v-col>
    </v-row>

    <div v-if="activeSubTab === 'overall'">
        <v-row justify="center" class="mt-4">
            <v-col align="center" cols="12">
                <v-btn v-model="overall" @click="getInstHomeworkData" :loading="loading4" color="brand" elevated style="color: white">
                    <v-icon left>mdi-chart-bar</v-icon>Overall
                </v-btn>
            </v-col>
        </v-row>
        <br>
        <div v-if="overall && this.homework_data != ''" class="d-flex flex-row align-center mt-4" style="width: 100%;">
            <chart 
                :options="homework_overall" 
                autoresize 
                style="width: 100%; height: 400px; border: 1px solid grey; border-radius: 12px; background-color: #ffffff;"
            ></chart>
        </div>
    </div>

    <div v-if="activeSubTab === 'filters'">
        <div class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Coursewise Homework Analysis</v-toolbar-title>
                <v-divider color="white" class="mx-4" inset vertical></v-divider>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required @change="getInstCourse(std)"
                        v-model="std" :items="std_list" item-text="std_name" return-object
                        label="Standard" outlined persistent-hint hint="Please Select Standard" />
                </v-col>
                <v-col cols="12" sm="3" v-if="course_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" @change="getInst(course)" dense rounded required
                        v-model="course" :items="course_list" item-text="coff_name" return-object
                        label="Course" outlined persistent-hint hint="Please Select Course" />
                </v-col>
                <v-col cols="12" sm="3" v-if="inst_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="inst"
                        :items="inst_list" item-text="inst_name" return-object label="Employee" outlined
                        persistent-hint hint="Please Select Employee" />
                </v-col>
                <v-col cols="12" sm="2" v-if="inst" align="left" style="align-content: center;">
                    <v-btn color="brand" dark class="fetch-btn" :loading="loader" v-model="showGraph"
                        @click="getInstHomeworkByAy()">Fetch</v-btn>
                </v-col>
            </v-row>
        </div>
        <br />
        <div v-if="showGraph && this.homework_data != ''" class="d-flex flex-row align-center mt-4" style="width: 100%;">
            <chart 
                :options="homework_byAy" 
                autoresize 
                style="width: 100%; height: 400px; border: 1px solid grey; border-radius: 12px; background-color: #ffffff;"
            ></chart>
        </div>
    </div>
</div>


                    <div v-if="selectedModule == 'Registration'">
    <v-col cols="12" sm="12" md="12" class="box">
        <v-toolbar flat dense class="toolbar">
            <v-toolbar-title>Registration</v-toolbar-title>
            <v-divider color="white" class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <v-row justify="center">
            <v-col cols="12" sm="3" class="mt-2">
                <v-autocomplete color="#0F2027" dense rounded outlined required @change="getInstCourse(std)"
                    v-model="std" :items="std_list" item-text="std_name" return-object
                    label="Standard" persistent-hint hint="Please Select Standard" />
            </v-col>
            <v-col cols="12" sm="5" v-if="course_list != ''" class="mt-2">
                <v-autocomplete color="#0F2027" dense rounded outlined required v-model="course"
                    :items="course_list" item-text="coff_name" return-object label="Course"
                    persistent-hint hint="Please Select Course" />
            </v-col>
            <v-col cols="12" sm="3" class="mt-2" v-if="course">
                <v-btn 
                    color="indigo" 
                    dark 
                    :loading="loader" 
                    class="fetch-btn"
                    @click="fetchCourseRegistrationData()"
                >
                    Fetch
                </v-btn>
            </v-col>
        </v-row>
    </v-col>

    <br />

    <div v-if="bar_graph_details != '' && showInfo" class="d-flex flex-row align-center mt-4" style="width: 100%;">
        <chart 
            :options="option" 
            autoresize 
            style="width: 100%; height: 500px; border: 1px solid #e0e0e0; border-radius: 12px; padding: 10px; background-color: #ffffff;"
        ></chart>
    </div>
</div>
    
                   <div v-if="selectedModule == 'Leave'">
  <v-col cols="12" class="box pa-4">
    <v-toolbar flat dense class="toolbar mb-4">
      <v-toolbar-title>Leave Analytics</v-toolbar-title>
    </v-toolbar>

    <!-- AY Filter -->
    <v-row justify="center" class="px-4 mb-6">
      <v-col cols="12" sm="6" md="5">
        <v-autocomplete
          color="#0F2027"
          dense
          rounded
          required
          v-model="selectedAy"
          :items="ayList"
          item-text="ay"
          item-value="id"
          label="Select Academic Year"
          outlined
          persistent-hint
          hint="Select academic year to view leave details"
          :loading="ayLoading"
          @change="fetchMyLeaveAnalytics"
        />
      </v-col>
    </v-row>
  </v-col>

  <div v-if="leaveDataLoaded">
    <!-- One card per leave type -->
    <v-row v-for="lt in filteredLeaveTypes" :key="lt.leaveType">
      <v-col cols="12">
        <v-card class="mb-10 pa-4" elevation="4">
          <!-- Header -->
          <v-row class="mb-6">
            <v-col cols="12" class="text-center">
              <span class="font-weight-bold text-subtitle-1">
                Leave Type: {{ lt.leaveType }}
              </span>
            </v-col>
          </v-row>

          <v-row align="center">
            <!-- Chart -->
            <v-col cols="12" md="9" class="d-flex justify-center align-center">
              <div
                class="chart-container"
                style="
                  width: 100%;
                  max-width: 600px;
                  height: 480px;
                  min-height: 400px;
                  border: 1px solid #ccc;
                  border-radius: 12px;
                  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
                  background: #fff;
                "
              >
                <chart
                  :options="getPieChartOptions(lt)"
                  auto-resize
                  style="width:100%; height:100%;"
                />
              </div>
            </v-col>

            <!-- Summary Squares -->
            <v-col cols="12" md="3" class="d-flex flex-column justify-center align-center align-md-start">
              <div style="width: 100%; max-width: 300px;">
                <!-- TOTAL -->
                <div
                  class="squares mb-4"
                  style="background:#40b8e6; border:4px solid #80d4f6; color:#ffffff;"
                >
                  <b>TOTAL</b> <b>{{ lt.total || 0 }}</b>
                </div>

                <!-- IN-PROCESS -->
                <div
                  class="squares mb-4"
                  style="background:#ffeb3b; border:4px solid #fff176; color:#212121;"
                >
                  <b>IN-PROCESS</b> <b>{{ lt.inProgress || 0 }}</b>
                </div>

                <!-- AVAILED -->
                <div
                  class="squares mb-4"
                  style="background:#f54a94; border:4px solid #fa8bb9; color:#ffffff;"
                >
                  <b>AVAILED</b> <b>{{ lt.availed || 0 }}</b>
                </div>

                <!-- BALANCE -->
                <div
                  class="squares"
                  style="background:#73d0a0; border:4px solid #a0e6c2; color:#212121;"
                >
                  <b>BALANCE</b> <b>{{ lt.balance || 0 }}</b>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- No data -->
    <v-alert v-if="filteredLeaveTypes.length === 0" type="warning" class="mt-4">
      No leave data found for the selected academic year.
    </v-alert>
  </div>

  <!-- Loading / no AY selected -->
  <div v-else class="text-center pa-12">
    <v-progress-circular v-if="loadingLeave" indeterminate color="primary" size="64"></v-progress-circular>
    <v-icon v-else size="80" color="grey lighten-1">mdi-calendar-clock</v-icon>
    <p class="mt-6 grey--text text--darken-1">
      {{ loadingLeave ? 'Loading leave analytics...' : 'Please select an Academic Year' }}
    </p>
  </div>

  <!-- Global Snackbar (already exists in your component) -->
  <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="4000" top>
    {{ snackbarText }}
    <v-btn dark text @click="snackbar = false">Close</v-btn>
  </v-snackbar>
</div>
                    <div v-if="selectedModule == 'Admission'">
                        <div class="box">
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Admission Analytics</v-toolbar-title>
                            </v-toolbar>
                    
                            <!-- Filters: Academic Year + Standard -->
                            <v-row justify="center" class="mt-6">
                                <v-col cols="12" sm="4">
                                    <v-autocomplete v-model="selectedAY" :items="ayList" item-text="ay" item-value="id"
                                        label="Academic Year" outlined dense rounded color="#0F2027" @change="fetchAdmissionData" />
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-autocomplete v-model="selectedStandard" :items="standardList" item-text="std_name" item-value="id"
                                        label="Standard" outlined dense rounded color="#0F2027" @change="fetchAdmissionData" />
                                </v-col>
                            </v-row>
                    
                            <!-- Radio buttons to switch between graphs -->
                            <v-radio-group v-model="admissionSubView" row class="mt-4 justify-center">
                                <v-radio color="brand" label="Number of Admissions" value="count"></v-radio>
                                <v-radio color="brand" label="Gender Ratio" value="gender"></v-radio>
                                <v-radio color="brand" label="Overall Gender" value="overall_gender"></v-radio>
                                <v-radio color="brand" label="Quota-wise" value="quota"></v-radio>
                                <v-radio color="brand" label="Religion-wise" value="religion"></v-radio>
                                <v-radio color="brand" label="Income Group" value="income"></v-radio>
                                <v-radio color="brand" label="Category-wise" value="category"></v-radio>
                            </v-radio-group>
                    
                            <!-- Number of Admissions Graph -->
                            <div v-if="admissionSubView === 'count' && admissionClasses.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_admission_count">
                                </chart>
                    
                            </div>
                    
                            <!-- Gender Ratio Graph -->
                            <div v-if="admissionSubView === 'gender' && genderClasses.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_admission_gender">
                                </chart>
                    
                            </div>
                            <!-- Overall Gender Distribution Pie Chart -->
                            <div v-if="admissionSubView === 'overall_gender' && overallGenderData.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_overall_gender">
                                </chart>
                    
                                <div class="mt-6 d-flex gap-8 justify-center">
                                    <div class="pa-4" style="background-color: #bbdefb; border: 4px solid #2196f3; border-radius: 8px;">
                                        <b>Male #</b><br>
                                        <span style="font-size: 24px; font-weight: bold; color: #1976d2;">{{ totalMale }}</span>
                                    </div>
                                    <div class="pa-4" style="background-color: #ffccbc; border: 4px solid #ff5722; border-radius: 8px;">
                                        <b>Female #</b><br>
                                        <span style="font-size: 24px; font-weight: bold; color: #d84315;">{{ totalFemale }}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- Quota-wise Admissions Graph -->
                            <div v-if="admissionSubView === 'quota' && quotaNames.length > 0" class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_quota_admissions">
                                </chart>
                    
                            </div>
                            <!-- Religion-wise Admissions Graph -->
                            <div v-if="admissionSubView === 'religion' && religionNames.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_religion_admissions">
                                </chart>
                    
                    
                            </div>
                            <!-- Income-Groupwise Admissions Graph -->
                            <div v-if="admissionSubView === 'income' && incomeGroups.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_income_admissions">
                                </chart>
                    
                                <div class="mt-6 d-flex gap-8 justify-center">
                                    <div class="squares2" style="background-color: #e3f2fd; border: 4px solid #90caf9;">
                                        <b>Dominant Income Group</b><br>
                                        <span style="font-size: 18px; color: #1976d2;">{{ dominantIncomeGroup }}</span>
                                    </div>
                                    <div class="squares2" style="background-color: #fff3e0; border: 4px solid #ffb74d;">
                                        <b>Total Groups</b><br>
                                        <span style="font-size: 18px; color: #ef6c00;">{{ totalIncomeGroups }}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- Category-wise Admissions Graph -->
                            <div v-if="admissionSubView === 'category' && categoryNames.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_category_admissions">
                                </chart>
                    
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedModule == 'Academics'">
                        <div class="box">
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Academics Analytics</v-toolbar-title>
                            </v-toolbar>
                            <v-row justify="center" class="mt-6">
                                <v-col cols="12" sm="4">
                                    <v-autocomplete v-model="selectedAY" :items="ayList" item-text="ay" item-value="id"
                                        label="Academic Year" outlined dense rounded color="#0F2027" @change="fetchAcademicsData" />
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-autocomplete v-model="selectedStandard" :items="standardList" item-text="std_name" item-value="id"
                                        label="Standard" outlined dense rounded color="#0F2027" @change="fetchAcademicsData" />
                                </v-col>
                            </v-row>
                            <v-radio-group v-model="academicsSubView" row class="mt-4 justify-center">
                                <v-radio color="brand" label="Syllabus Completion %" value="syllabus"></v-radio>
                                <v-radio color="brand" label="Planned Vs Actual Progress" value="progress"></v-radio>
                                <v-radio color="brand" label="Time Taken Per Chapter" value="chapter_time"></v-radio>
                                <v-radio color="brand" label="Classwise Completion %" value="classwise"></v-radio>
                                <v-radio color="brand" label="Topics Planned Vs Covered" value="topics"></v-radio>
                                <v-radio color="brand" label="Classwise Attendance %" value="attendance"></v-radio>
                            </v-radio-group>
                    
                            <!-- Grade-wise Syllabus Completion % Bar Chart -->
                            <div v-if="academicsSubView === 'syllabus' && syllabusClasses.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_syllabus_completion">
                                </chart>
                            </div>
                            <div v-if="academicsSubView === 'progress' && progressWeeks.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_progress_chart">
                                </chart>
                            </div>
                            <div v-if="academicsSubView === 'chapter_time' && chapterNames.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_chapter_time">
                                </chart>
                            </div>
                            <!-- 4. Classwise Syllabus Completion %  -->
                            <div v-if="academicsSubView === 'classwise' && classwiseClasses.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_classwise_completion">
                                </chart>
                            </div>
                            <!-- 5. Topics Planned Vs Topics Covered -->
                            <div v-if="academicsSubView === 'topics' && topicsClasses.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_topics_planned_covered">
                                </chart>
                            </div>
                            <!-- 6. Classwise Attendance % -->
                            <div v-if="academicsSubView === 'attendance' && attendanceClasses.length > 0"
                                class="d-flex flex-column align-center mt-10">
                                <chart
                                    style="width: 950px; height: 520px; border: 1px solid #ddd; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: white;"
                                    auto-resize :options="option_classwise_attendance">
                                </chart>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedModule === 'Transport'">
                        <div class="box">
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Transport Analytics</v-toolbar-title>
                            </v-toolbar>
                    
                            <!-- Filters -->
                            <v-row justify="center" class="mt-6">
                                <v-col cols="12" sm="4">
                                    <v-autocomplete v-model="selectedTransportAY" :items="ayList" item-text="ay" item-value="id"
                                        label="Academic Year" outlined dense rounded color="#0F2027" :loading="transportLoading"
                                        @change="fetchTransportData" />
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-autocomplete v-model="selectedTransportStandard" :items="standardList" item-text="std_name"
                                        item-value="id" label="Standard" outlined dense rounded color="#0F2027" :loading="transportLoading"
                                        @change="fetchTransportData" />
                                </v-col>
                            </v-row>
                    
                            <!-- Main Chart – Class-wise Transport Modes -->
                            <!-- Main Content: Scrollable Horizontal Bar Chart -->
                            <div v-if="transportClasses.length > 0" class="d-flex flex-column align-center mt-10">
                                <!-- Scrollable wrapper -->
                                <div class="topic-scrollable-container">
                                    <div :style="{
                                              width: '100%',
                                              maxWidth: '1400px',
                                              height: Math.max(450, transportClasses.length * 40) + 'px',
                                              margin: '0 auto'
                                            }">
                                        <chart class="topic-chart-inner" auto-resize :options="transport_classwise_horizontal"
                                            style="width: 100%; height: 100%;"></chart>
                                    </div>
                                </div>
                            </div>
                    
                            <!-- No data placeholder -->
                            <v-card v-else class="text-center pa-12 mt-10" flat>
                                <v-icon size="80" color="grey lighten-1">mdi-bus-school</v-icon>
                                <p class="mt-6 grey--text text--darken-1">
                                    Select Academic Year and Standard to view transport analytics
                                </p>
                            </v-card>
                    
                            <div v-if="grade_wise_transport_data.length > 0" class="mt-16">
                                <h3 class="text-h5 text-center mb-6 font-weight-bold">
                                    Transport - Option Grade-wise Analysis
                                </h3>
                                <div style="width: 100%; max-width: 1100px; height: 480px; margin: 0 auto;">
                                    <chart auto-resize :options="grade_wise_transport_options" style="width: 100%; height: 100%;"></chart>
                                </div>
                            </div>
                    
                            <!-- No data message for grade-wise -->
                            <div v-else-if="transportClasses.length > 0" class="text-center mt-12 grey--text text--darken-1">
                                No grade-wise transport data available for selected filters
                            </div>
                            <!-- 3. Fees Due by Grade/Class – Horizontal bars + Scroll -->
                            <div v-if="standardWiseDues.length > 0" class="mt-16">
                                <div class="topic-scrollable-container">
                                    <div :style="{
                                              width: '100%',
                                              maxWidth: '1400px',
                                              height: Math.max(450, standardWiseDues.length * 50) + 'px',
                                              margin: '0 auto'
                                            }">
                                        <chart class="topic-chart-inner" auto-resize :options="fees_due_horizontal"
                                            style="width: 100%; height: 100%;"></chart>
                                    </div>
                                </div>
                    
                                <div class="mt-6 text-center">
                                    <v-chip color="error" class="mr-3">
                                        Total Fees Due: {{ totalFeesDue.toFixed(2) }} Lakhs
                                    </v-chip>
                                </div>
                            </div>
                    
                            <div v-else-if="transportClasses.length > 0" class="text-center mt-12 grey--text text--darken-1">
                                No fees due data available for the selected filters
                            </div>
                            <!-- 4. Payment On Time vs Late Payment – Horizontal bars + Scroll -->
                            <div v-if="paymentStatsByStandard.length > 0" class="mt-16">
                                <div class="topic-scrollable-container">
                                    <div :style="{
                                              width: '100%',
                                              maxWidth: '1400px',
                                              height: Math.max(450, paymentStatsByStandard.length * 50) + 'px',
                                              margin: '0 auto'
                                            }">
                                        <chart class="topic-chart-inner" auto-resize :options="payment_stats_horizontal"
                                            style="width: 100%; height: 100%;"></chart>
                                    </div>
                                </div>
                    
                                <div class="mt-6 text-center">
                                    <v-chip color="blue" class="mr-3">
                                        Total On-Time: {{ totalOnTime }}
                                    </v-chip>
                                    <v-chip color="orange" class="mr-3">
                                        Total Late: {{ totalLate }}
                                    </v-chip>
                                </div>
                            </div>
                    
                            <div v-else-if="transportClasses.length > 0" class="text-center mt-12 grey--text text--darken-1">
                                No payment stats available for the selected filters
                            </div>
                        </div>
                    </div>
                    </v-col>
                    </v-row>
                    </v-card>
                    </div>
                    </template>
                    
                    <script>
                        import "@/assets/css/color.css"; // css needs to be imported for each dashboard
                        import epsHeader from "../shared/UpdatedHeader";
import axios from "axios";
// import loader from "sass-loader";
export default {
    data: () => ({
        activeSubTab: "overall",
        snackbar_msg: "",
        color: "",
        snackbar: false,
        appraisal: false,
        profile: false,
        // feedback: false,
        biometric: false,
        result: false,
        quiz: false,
        homework: false,
        registration: false,
        leave: false,
        overall: false,
        profile_overall: false,
        filtered: false,
        profile_filtered: false,
        profile_filtered_publications: false,
        profile_filtered_trainings: false,
        profile_filtered_activities: false,
        loader: false,
        modules: false,
        loader2: false,
        loader3: false,
        getInstructorAttendanceAnalyticsByAy_fetch: false,
        getInstructoPublicationAnalyticsByAy_fetch: false,
        getInstructoPublicationAnalyticsByAy_fetch_2: false,
        getInstructoTrainingAnalyticsByAy_fetch: false,
        getInstructoTrainingAnalyticsByAy_fetch_2: false,
        getInstructoTActivityAnalyticsByAy_fetch: false,
        getInstructoTActivityAnalyticsByAy_fetch_2: false,
        loading1: false,
        loading3: false,
        loading4: false,
        fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
        todate: new Date().toISOString().slice(0, 10),
        activeTab: 'Publication',  // Default active tab
        // selectedModule: "",
        selectedModule: "Admission", 
        

    moduleTabs: [
        // "Profile",
        // "Feedback",
        // "Biometric",
        "Admission",
        "Transport",
        "Result",
        "Academics",
        "Appraisal",
        // "Quiz",
        // "Homework",
        // "Registration",
        "Leave",
    ],
        std_list: [],
        ay_list_other: [],
        ay_list_is_inerp: [],
        std: null,
        course_list: [],
        course: null,
        inst_list: [],
        inst: null,
        std_list: [],
        std: null,
        course_list: [],
        course: null,
        semester_list: [],
        semester: null,
        bar_graph_details: [],
        semester_list: [],
        semester: null,
        result_bar_graph_details: [],
        avg_ass_type_result_bar_graph_details: [],
        marks_bar_graph_details: [],
        radios: null,
        publicaton_radios: null,
        training_radios: null,
        activities_radios: null,
        ay: null,
        ay_other: null,
        ay_activities: null,
        ay_is_inerp: null,
        leaveType: null,
        apply: false,
        ay_list: [],
        homework_data: [],
        showGraph: false,
        quiz_data: [],
        totalValue: 0,
        inProgressValue: 0,
        availedValue: 0,
        balanceValue: 0,
        profile_overall_2: false,
        profile_overall_3: false,
        totalTrainings: 0,
        totalActivities: 0,
        totalPublications: 0,
        totalPublicationsByAy: 0,
        totalTrainingsByAy: 0,
        totalActivitiesByAy: 0,
        totalAverageWorkingHours: 0,
        resultBarGraphSum: 0,
        showInfo: false,
        CourseDetails: false,
        admission: false,
selectedAY: null,
selectedStandard: null,
ayList: [],
standardList: [],
admissionClasses: [],
admissionCounts: [],
highestAdmissionClass: "N/A",
totalAdmissions: 0,

option_admission_count: {
    title: { text: 'Number of Admissions', left: 'center', top: 20, textStyle: { fontSize: 20, fontWeight: 'bold' } },
    tooltip: { trigger: 'axis', formatter: '{b}: {c} students' },
    grid: { top: 80, bottom: 80, containLabel: true },
    xAxis: {
        type: 'category',
        data: [],
        name: 'Class',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Admissions #',
        min: 0,
        interval: 5
    },
    series: [{
        name: 'Admissions',
        type: 'bar',
        barWidth: '50%',
        data: [],
        itemStyle: { color: '#5470C6', borderRadius: [8, 8, 0, 0] },
        label: { show: true, position: 'top', fontSize: 18, fontWeight: 'bold', formatter: '{c}' }
    }]
},
admissionSubView: 'count',  // default view
genderClasses: [],
maleAdmissions: [],
femaleAdmissions: [],

option_admission_gender: {
    title: {
        text: 'Admission Gender Ratio',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: { trigger: 'axis', formatter: '{b}<br>{a}: {c} students' },
    legend: { data: ['Male', 'Female'], bottom: 10 },
    grid: { top: 80, bottom: 80, containLabel: true },
    xAxis: {
        type: 'category',
        data: [],
        name: 'Class',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Admissions #',
        min: 0,
        interval: 5
    },
    series: [
        {
            name: 'Male',
            type: 'bar',
            barWidth: 30,
            itemStyle: { color: '#5470C6' },
            label: { show: true, position: 'top', fontSize: 16, fontWeight: 'bold' },
            data: []
        },
        {
            name: 'Female',
            type: 'bar',
            barWidth: 30,
            itemStyle: { color: '#EE6666' },
            label: { show: true, position: 'top', fontSize: 16, fontWeight: 'bold' },
            data: []
        }
    ]
},
admissionSubView: 'count',  
overallGenderData: [],
totalMale: 0,
totalFemale: 0,
option_overall_gender: {
    title: {
        text: 'Overall Gender Distribution',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
        orient: 'vertical',
        right: 'right',
        top: 'middle',
        formatter: function(name) {
            // Will be overridden dynamically
            return name;
        }
    },
    series: [{
        name: 'Students',
        type: 'pie',
        radius: '70%',
        center: ['50%', '50%'],
        itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 4
        },
        label: {
            show: true,
            position: 'inside',
            fontSize: 24,
            fontWeight: 'bold',
            color: '#fff',
            formatter: '{d}%'  // Only percentage inside
        },
        emphasis: {
            itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
        },
        data: []
    }]
},
quotaNames: [],
quotaSeries: [],
highestQuota: "N/A",
totalQuotas: 0,
option_quota_admissions: {
    title: {
        text: 'Quota-wise Admissions',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}<br>{a}: {c} students'
    },
    legend: {
        data: [],  // Will be filled with division names
        bottom: 10
    },
    grid: {
        top: 80,
        bottom: 100,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],  // Quota names
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold',
            interval: 0,
            rotate: 30
        },
        name: 'Quota',
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Admissions #',
        min: 0,
        interval: 10
    },
    series: []  // One series per division (Grade 9-A, 9-B, etc.)
},
religionNames: [],
religionSeries: [],
dominantReligion: "N/A",
totalReligions: 0,
option_religion_admissions: {
    title: {
        text: 'Religionwise Admissions',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}<br>{a}: {c} students'
    },
    legend: {
        data: [],  // Divisions
        bottom: 10
    },
    grid: {
        top: 80,
        bottom: 100,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],  // Religions
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold',
            interval: 0,
            rotate: 30
        },
        name: 'Religion',
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Admissions #',
        min: 0,
        interval: 10
    },
    series: []  // One per division
},
incomeGroups: [],
incomeSeries: [],
dominantIncomeGroup: "N/A",
totalIncomeGroups: 0,
option_income_admissions: {
    title: {
        text: 'Income-Groupwise Admissions',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}<br>{a}: {c} students'
    },
    legend: {
        data: [],  // Divisions
        bottom: 10
    },
    grid: {
        top: 80,
        bottom: 100,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],  // Income groups
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold',
            interval: 0,
            rotate: 0
        },
        name: 'Income Group',
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Admissions #',
        min: 0,
        interval: 10
    },
    series: []  // One per division
},
categoryNames: [],
categorySeries: [],
dominantCategory: "N/A",
totalCategories: 0,
option_category_admissions: {
    title: {
        text: 'Categorywise Admissions',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}<br>{a}: {c} students'
    },
    legend: {
        data: [],  // Will be filled with classes (Grade 9-A, etc.)
        bottom: 10
    },
    grid: {
        top: 80,
        bottom: 120,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],  // ← Categories (General, OBC, etc.)
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold',
            interval: 0,
            rotate: 30
        },
        name: 'Category',
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Admissions #',
        min: 0,
        interval: 10
    },
    series: []  // One series per class (Grade 9-A, 9-B, etc.)
},
academics: false,
academicsSubView: 'syllabus', // default view
syllabusClasses: [],
syllabusPercentages: [],
highestSyllabusClass: "N/A",
lowestSyllabusClass: "N/A",
option_syllabus_completion: {
    title: {
        text: 'Grade-wise Syllabus Completion %',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}: {c}%'
    },
    grid: {
        top: 80,
        bottom: 80,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold',
            color: '#333'
        },
        name: 'Grade',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Completion %',
        min: 0,
        max: 100,
        interval: 10,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' },
        axisLabel: {
            formatter: '{value}%'
        }
    },
    series: [{
        name: 'Completion %',
        type: 'bar',
        barWidth: '50%',
        data: [],
        itemStyle: {
            color: '#5470C6',
            borderRadius: [8, 8, 0, 0]
        },
        label: {
            show: true,
            position: 'top',
            fontSize: 18,
            fontWeight: 'bold',
            color: '#000',
            formatter: '{c}%'
        }
    }]
},
progressWeeks: [],
plannedProgress: [],
actualProgress: [],

option_progress_chart: {
    title: {
        text: 'Syllabus Planned Vs Actual Progress',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b} Week<br>{a0}: {c0}%<br>{a1}: {c1}%'
    },
    legend: {
        data: ['Planned', 'Actual Progress %'],
        bottom: 10
    },
    grid: {
        top: 80,
        bottom: 80,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],
        name: 'Week',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Progress %',
        min: 0,
        max: 120,
        interval: 20,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' },
        axisLabel: { formatter: '{value}%' }
    },
    series: [
        {
            name: 'Planned',
            type: 'line',
            data: [],
            itemStyle: { color: '#FF8C00' }, 
            lineStyle: { width: 4 },
            symbolSize: 8,
            label: { show: true, position: 'top', fontSize: 16, fontWeight: 'bold' }
        },
        {
            name: 'Actual Progress %',
            type: 'line',
            data: [],
            itemStyle: { color: '#757575' }, 
            lineStyle: { width: 4 },
            symbolSize: 8,
            label: { show: true, position: 'top', fontSize: 16, fontWeight: 'bold' }
        }
    ]
},
// For Time Taken Per Chapter
chapterNames: [],
chapterHours: [],
longestChapter: "N/A",
shortestChapter: "N/A",

option_chapter_time: {
    title: {
        text: 'Time Taken Per Chapter',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}<br>{a}: {c} hours'
    },
    grid: {
        top: 80,
        bottom: 80,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],
        name: 'Chapter',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' },
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold'
        }
    },
    yAxis: {
        type: 'value',
        name: 'Hours',
        min: 0,
        interval: 1,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    series: [{
        name: 'Hours',
        type: 'bar',
        barWidth: '50%',
        data: [],
        itemStyle: {
            color: '#5470C6',
            borderRadius: [8, 8, 0, 0]
        },
        label: {
            show: true,
            position: 'top',
            fontSize: 18,
            fontWeight: 'bold',
            formatter: '{c}'
        }
    }]
},
// For Classwise Syllabus Completion %
classwiseClasses: [],
classwisePercentages: [],
highestClasswise: "N/A",
lowestClasswise: "N/A",

option_classwise_completion: {
    title: {
        text: 'Classwise Syllabus Completion %',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}<br>{a}: {c}%'
    },
    grid: {
        top: 80,
        bottom: 80,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],
        name: 'Class',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' },
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold',
            rotate: 0
        }
    },
    yAxis: {
        type: 'value',
        name: 'Completion %',
        min: 0,
        max: 100,
        interval: 10,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' },
        axisLabel: { formatter: '{value}%' }
    },
    series: [{
        name: 'Completion %',
        type: 'bar',
        barWidth: '50%',
        data: [],
        itemStyle: {
            color: '#5470C6',
            borderRadius: [8, 8, 0, 0]
        },
        label: {
            show: true,
            position: 'top',
            fontSize: 18,
            fontWeight: 'bold',
            color: '#000',
            formatter: '{c}%'
        }
    }]
},
topicsClasses: [],
plannedTopics: [],
coveredTopics: [],
bestCoverageClass: "N/A",
mostBehindClass: "N/A",

option_topics_planned_covered: {
    title: {
        text: 'Topics Planned Vs Topics Covered',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}<br>{a0}: {c0}<br>{a1}: {c1}'
    },
    legend: {
        data: ['Topics Planned #', 'Topics Covered #'],
        bottom: 10
    },
    grid: {
        top: 80,
        bottom: 100,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],
        name: 'Class',
        nameLocation: 'middle',
        nameGap: 50,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' },
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold',
            rotate: 0
        }
    },
    yAxis: {
        type: 'value',
        name: 'Topics #',
        min: 0,
        interval: 10,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    series: [
        {
            name: 'Topics Planned #',
            type: 'bar',
            barWidth: 30,
            itemStyle: { color: '#5470C6' },
            label: { show: true, position: 'top', fontSize: 16, fontWeight: 'bold' },
            data: []
        },
        {
            name: 'Topics Covered #',
            type: 'bar',
            barWidth: 30,
            itemStyle: { color: '#EE8C00' },
            label: { show: true, position: 'top', fontSize: 16, fontWeight: 'bold' },
            data: []
        }
    ]
},
// For Classwise Attendance %
attendanceClasses: [],
attendancePercentages: [],
bestAttendanceClass: "N/A",
lowestAttendanceClass: "N/A",

option_classwise_attendance: {
    title: {
        text: 'Classwise Attendance %',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}<br>{a}: {c}%'
    },
    grid: {
        top: 80,
        bottom: 80,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],
        name: 'Class',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' },
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold'
        }
    },
    yAxis: {
        type: 'value',
        name: 'Attendance %',
        min: 0,
        max: 100,
        interval: 10,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' },
        axisLabel: { formatter: '{value}%' }
    },
    series: [{
        name: 'Attendance %',
        type: 'bar',
        barWidth: '50%',
        data: [],
        itemStyle: {
            color: '#5470C6',
            borderRadius: [8, 8, 0, 0]
        },
        label: {
            show: true,
            position: 'top',
            fontSize: 18,
            fontWeight: 'bold',
            color: '#000',
            formatter: '{c}%'
        }
    }]
},
        highestClass: "N/A",
        lowestClass: "N/A",
        option: {
    backgroundColor: "#ffffff",
    title: {
        text: "Subject Registration",
        left: "center",
        top: 10,
        textStyle: { fontSize: 16, fontWeight: "550", color: "#1E293B" },
    },
    tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow", shadowStyle: { color: "rgba(0,0,0,0.04)" } },
    },
    /* Restored Switch Functionality */
    toolbox: {
        show: true,
        right: 20,
        feature: {
            mark: { show: true },
            magicType: {
                show: true,
                type: ["line", "bar", "stack"],
                title: {
                    line: "Switch to Line Chart",
                    bar: "Switch to Bar Chart",
                    stack: "Switch to Stack Chart",
                },
            },
            restore: { show: true, title: "Restore" },
            saveAsImage: { show: true, title: "Save As Image" },
        },
    },
    grid: {
        top: "15%",
        left: "3%",
        right: "3%",
        bottom: "10%",
        containLabel: true
    },
    xAxis: {
        type: "category",
        data: [], 
        axisLabel: { rotate: 30, color: "#475569", fontSize: 12 },
        axisLine: { lineStyle: { color: "#CBD5E1" } },
        axisTick: { show: false },
    },
    yAxis: {
        type: "value",
        name: "count",
        splitLine: { lineStyle: { color: "#E5E7EB", type: "dashed" } },
    },
    series: [
        {
            name: "count",
            type: "bar",
            data: [], 
            barWidth: "40%",
            itemStyle: {
                borderRadius: [10, 10, 0, 0],
                color: {
                    type: "linear", x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: "#34D399" }, // Light Emerald
                        { offset: 1, color: "#059669" }, // Dark Emerald
                    ],
                },
            },
            label: {
                show: true,
                position: "top",
                fontWeight: "bold",
                color: "#1E293B",
            },
        },
    ],
},
      option1: {
    backgroundColor: "#ffffff",

    title: {
        text: "Overall Avg Working Hours",
        left: "center",
        top: 10,
        textStyle: {
            fontSize: 16,
            fontWeight: "550",
            color: "#1E293B", // slate-800
        },
    },

    color: ["#2563EB", "#F59E0B"],

    tooltip: {
        trigger: "axis",
        axisPointer: {
            type: "shadow",
            shadowStyle: {
                color: "rgba(0,0,0,0.04)",
            },
        },
        backgroundColor: "rgba(30,41,59,0.95)",
        borderRadius: 10,
        padding: [10, 14],
        textStyle: {
            color: "#FFFFFF",
            fontSize: 13,
        },
    },

    toolbox: {
    show: true,
    right: 18,
    top: 12,
    iconStyle: {
        borderColor: "#64748B",
    },
    emphasis: {
        iconStyle: {
            borderColor: "#2563EB",
        },
    },
    feature: {
        mark: { show: true },

        magicType: {
            show: true,
            type: ["line", "bar", "stack"],
            title: {
                line: "Switch to Line Chart",
                bar: "Switch to Bar Chart",
                stack: "Switch to Stack Chart",
            },
        },

        restore: {
            show: true,
            title: "Restore",
        },

        saveAsImage: {
            show: true,
            title: "Save As Image",
            backgroundColor: "#ffffff",
        },
    },
},

    legend: {
        bottom: 8,
        itemGap: 24,
        icon: "roundRect",
        itemWidth: 14,
        itemHeight: 14,
        textStyle: {
            fontSize: 12,
            color: "#475569",
        },
    },

  grid: {
        top: "15%",
        left: "3%",    // Keeps bars close to the left border
        right: "2%",   // Keeps bars close to the right border
        bottom: "10%",
        containLabel: true // Ensures Y-axis numbers aren't cut off
    },

    xAxis: {
        type: "category",
        data: [],
        axisLabel: {
            rotate: 30,
            color: "#475569",
            fontSize: 12,
        },
        axisLine: {
            lineStyle: {
                color: "#CBD5E1",
            },
        },
        axisTick: {
            show: false,
        },
    },

    yAxis: {
        type: "value",
        name: "Hours",
        nameGap: 12,
        nameTextStyle: {
            color: "#475569",
            fontSize: 12,
        },
        axisLabel: {
            color: "#475569",
            fontSize: 12,
        },
        axisLine: {
            show: false,
        },
        splitLine: {
            lineStyle: {
                color: "#E5E7EB",
                type: "dashed",
            },
        },
    },

    series: [
        {
            name: "Average Working Hours",
            data: [],
            type: "bar",
            barWidth: "32%",
            itemStyle: {
                borderRadius: [10, 10, 0, 0],
                color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                        { offset: 0, color: "#3B82F6" },
                        { offset: 1, color: "#1E40AF" },
                    ],
                },
            },
            label: {
                show: true,
                position: "top",
                fontSize: 11,
                fontWeight: 500,
                color: "#1E293B",
            },
        },
        {
            name: "Average Present Hours",
            data: [],
            type: "bar",
            barWidth: "32%",
            itemStyle: {
                borderRadius: [10, 10, 0, 0],
                color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                        { offset: 0, color: "#FBBF24" },
                        { offset: 1, color: "#D97706" },
                    ],
                },
            },
            label: {
                show: true,
                position: "top",
                fontSize: 11,
                fontWeight: 500,
                color: "#1E293B",
            },
        },
    ],
},

  option2: {
  backgroundColor: "#ffffff",

  title: {
    text: "Avg Working Hours",
    left: "center",
    top: 10,
    textStyle: {
      fontSize: 16,
      fontWeight: "550",
      color: "#475569",
    },
  },

  color: ["#2563EB", "#F59E0B"],

  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
      shadowStyle: {
        color: "rgba(0,0,0,0.04)",
      },
    },
    backgroundColor: "rgba(30,41,59,0.95)",
    borderRadius: 10,
    padding: [10, 14],
    textStyle: {
      color: "#FFFFFF",
      fontSize: 13,
    },
  },

  toolbox: {
    show: true,
    right: 18,
    top: 12,
    iconStyle: {
      borderColor: "#64748B",
    },
    emphasis: {
      iconStyle: {
        borderColor: "#2563EB",
      },
    },
    feature: {
      mark: { show: true },

      magicType: {
        show: true,
        type: ["line", "bar", "stack"],
        title: {
          line: "Switch to Line Chart",
          bar: "Switch to Bar Chart",
          stack: "Switch to Stack Chart",
        },
      },

      restore: {
        show: true,
        title: "Restore",
      },

      saveAsImage: {
        show: true,
        title: "Save As Image",
        backgroundColor: "#ffffff",
      },
    },
  },

  legend: {
    bottom: 8,
    itemGap: 24,
    icon: "roundRect",
    itemWidth: 14,
    itemHeight: 14,
    textStyle: {
      fontSize: 12,
      color: "#475569",
    },
  },

  grid: {
        top: "15%",    // Space for the title and toolbox icons
        left: "4%",    // Minimal space for Y-axis labels (Hours)
        right: "4%",   // Minimal space on the right
        bottom: "12%", // Space for X-axis labels (Years)
        containLabel: true // This keeps the text inside the 100% width
    },

  xAxis: {
    type: "category",
    data: [],
    axisLabel: {
      rotate: 30,
      color: "#475569",
      fontSize: 12,
    },
    axisLine: {
      lineStyle: {
        color: "#CBD5E1",
      },
    },
    axisTick: {
      show: false,
    },
  },

  yAxis: {
    type: "value",
    name: "Hours",
    nameGap: 12,
    nameTextStyle: {
      color: "#475569",
      fontSize: 12,
    },
    axisLabel: {
      color: "#475569",
      fontSize: 12,
    },
    axisLine: {
      show: false,
    },
    splitLine: {
      lineStyle: {
        color: "#E5E7EB",
        type: "dashed",
      },
    },
  },

  series: [
    {
      name: "Average Working Hours",
      data: [],
      type: "bar",
      barWidth: "32%",
      barGap: "20%",
      barCategoryGap: "40%",
      itemStyle: {
        borderRadius: [10, 10, 0, 0],
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            { offset: 0, color: "#3B82F6" },
            { offset: 1, color: "#1E40AF" },
          ],
        },
      },
      label: {
        show: true,
        position: "top",
        fontSize: 11,
        fontWeight: 500,
        color: "#1E293B",
      },
    },
    {
      name: "Average Present Hours",
      data: [],
      type: "bar",
      barWidth: "32%",
      itemStyle: {
        borderRadius: [10, 10, 0, 0],
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            { offset: 0, color: "#FBBF24" },
            { offset: 1, color: "#D97706" },
          ],
        },
      },
      label: {
        show: true,
        position: "top",
        fontSize: 11,
        fontWeight: 500,
        color: "#1E293B",
      },
    },
  ],
},

        publication_option: {
            title: {
                text: "Publications",
                left: "center",
            },
            color: ["#FF5F00", "#002379"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                },
            },
            calculable: true,
            legend: {
                data: ["Publications"], // Match the series names
                itemGap: 15,
                bottom: 0,
            },
            grid: {
                top: "15%",
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 45,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "",
                nameLocation: "end",
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Publications",
                nameLocation: "end",
                offset: 10,
            },
            series: [

                {
                    name: "Publications",
                    data: [],
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                    },
                },
            ],
        },
        publication_by_ay_option: {
            title: {
                text: "Publications",
                left: "center",
            },
            color: ["#FF5F00", "#002379"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                },
            },
            calculable: true,
            legend: {
                data: ["Publications"], // Match the series names
                itemGap: 15,
                bottom: 0,
            },
            grid: {
                top: "15%",
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 45,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "",
                nameLocation: "end",
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Publications",
                nameLocation: "end",
                offset: 10,
            },
            series: [

                {
                    name: "Publications",
                    data: [],
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                    },
                },
            ],
        },
        training_option: {
            title: {
                text: "Trainings",
                left: "center",
            },
            color: ["#FF5F00", "#002379"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                },
            },
            calculable: true,
            legend: {
                data: ["Participated"], // Match the series names
                itemGap: 15,
                bottom: 0,
            },
            grid: {
                top: "15%",
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 45,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "",
                nameLocation: "end",
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Participated",
                nameLocation: "end",
                offset: 10,
            },
            series: [

                {
                    name: "Participated",
                    data: [],
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                    },
                },
            ],
        },
        training_by_ay_option: {
            title: {
                text: "Trainings",
                left: "center",
            },
            color: ["#FF5F00", "#002379"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                },
            },
            calculable: true,
            legend: {
                data: ["Participated"], // Match the series names
                itemGap: 15,
                bottom: 0,
            },
            grid: {
                top: "15%",
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 45,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "",
                nameLocation: "end",
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Participated",
                nameLocation: "end",
                offset: 10,
            },
            series: [

                {
                    name: "Participated",
                    data: [],
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                    },
                },
            ],
        },
        activities_option: {
            title: {
                text: "Activities",
                left: "center",
            },
            color: ["#FF5F00", "#002379"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                },
            },
            calculable: true,
            legend: {
                data: ["Organized"], // Match the series names
                itemGap: 15,
                bottom: 0,
            },
            grid: {
                top: "15%",
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 45,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "",
                nameLocation: "end",
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Organized",
                nameLocation: "end",
                offset: 10,
            },
            series: [

                {
                    name: "Organized",
                    data: [],
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                    },
                },
            ],
        },
        activities_by_ay_option: {
            title: {
                text: "Activities",
                left: "center",
            },
            color: ["#FF5F00", "#002379"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                },
            },
            calculable: true,
            legend: {
                data: ["Organized"], // Match the series names
                itemGap: 15,
                bottom: 0,
            },
            grid: {
                top: "15%",
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 45,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "",
                nameLocation: "end",
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Organized",
                nameLocation: "end",
                offset: 10,
            },
            series: [

                {
                    name: "Organized",
                    data: [],
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                    },
                },
            ],
        },

        option_result: {
            title: {
                text: "Subject Grade Score Details",
                left: "center",
            },
            color: ["#AFB42B"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                },
            },
            calculable: true,
            legend: {
                data: ["Growth", "Budget 2011", "Budget 2012"],
                itemGap: 5,
            },
            grid: {
                top: "12%",
                // left: '1%',
                // right: '10%',
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 75,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "Grade",
                nameLocation: "middle",
                nameTextStyle: {
                    fontSize: 16,
                    color: '#333',
                    padding: 20
                },
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Count",
                nameLocation: "end",
                offset: 10,
            },
            series: [
                {
                    data: [],
                    value: [],
                    type: "bar",
                },
            ],
        },
        option_avg_result: {
            title: {
                text: "Assesment Type Avg Score Details",
                left: "center",
            },
            color: ["#AFB42B"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                },
            },
            calculable: true,
            legend: {
                data: ["Growth", "Budget 2011", "Budget 2012"],
                itemGap: 5,
            },
            grid: {
                top: "12%",
                // left: '1%',
                // right: '10%',
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 75,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "Assesment Type",
                nameLocation: "middle",
                nameTextStyle: {
                    fontSize: 16,
                    color: '#333',
                    padding: 70,
                },
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Avg % Score",
                nameLocation: "end",
                offset: 10,
            },
            series: [
                {
                    data: [],
                    value: [],
                    type: "bar",
                },
            ],
        },
        option_marks_result: {
            title: {
                text: "Subject Score Details",
                left: "center",
            },
            color: ["#AFB42B"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                },
            },
            calculable: true,
            legend: {
                data: ["Growth", "Budget 2011", "Budget 2012"],
                itemGap: 5,
            },
            grid: {
                top: "12%",
                // left: '1%',
                // right: '10%',
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 75,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "Marks Range",
                nameLocation: "middle",
                nameTextStyle: {
                    fontSize: 16,
                    color: '#333',
                    padding: 80,
                },
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Students",
                nameLocation: "end",
                offset: 10,
            },
            series: [
                {
                    data: [],
                    value: [],
                    type: "bar",
                },
            ],
        },
        option_class_avg: {
            title: {
                text: "Class-wise Average Marks",
                left: "center",
                top: "20px",
                textStyle: { fontSize: 18, fontWeight: "bold" }
            },
            color: ["#3398DB"],
            tooltip: {
                trigger: "axis",
                formatter: "{b}: {c} marks"
            },
            grid: {
                top: 80,
                bottom: 60,
                containLabel: true
            },
            xAxis: {
                type: "category",
                data: [],  // Will be filled dynamically
                axisLabel: {
                    rotate: 0,
                    fontSize: 13,
                    fontWeight: "bold",
                    color: "#333"
                },
                name: "Class",
                nameLocation: "middle",
                nameGap: 35,
                nameTextStyle: { fontWeight: "bold", fontSize: 14 }
            },
            yAxis: {
                type: "value",
                name: "Average Marks",
                min: 0,
                max: 100,
                interval: 10,
                nameLocation: "middle",
                nameGap: 50,
                nameTextStyle: { fontWeight: "bold", fontSize: 14 }
            },
            series: [{
                name: "Avg Marks",
                type: "bar",
                barWidth: "50%",
                data: [],  // Will be filled dynamically
                label: {
                    show: true,
                    position: "top",
                    formatter: "{c}",
                    fontWeight: "bold",
                    fontSize: 14
                },
                itemStyle: {
                    borderRadius: [5, 5, 0, 0],
                    shadowBlur: 10,
                    shadowColor: "rgba(0,0,0,0.3)"
                }
            }]
        },
        highestGrade: "N/A",
        lowestGrade: "N/A",
        option_grade_avg: {
            title: {
                text: "Grade-wise Average Marks",
                left: "center",
                top: "20px",
                textStyle: { fontSize: 18, fontWeight: "bold" }
            },
            color: ["#4285F4"],
            tooltip: {
                trigger: "axis",
                formatter: "{b}: {c} marks"
            },
            grid: {
                top: 80,
                bottom: 60,
                containLabel: true
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    fontSize: 13,
                    fontWeight: "bold",
                    color: "#333"
                },
                name: "Grade",
                nameLocation: "middle",
                nameGap: 35,
                nameTextStyle: { fontWeight: "bold", fontSize: 14 }
            },
            yAxis: {
                type: "value",
                name: "Avg Marks",
                min: 0,
                max: 100,
                interval: 10,
                nameLocation: "middle",
                nameGap: 50,
                nameTextStyle: { fontWeight: "bold", fontSize: 14 }
            },
            series: [{
                name: "Avg Marks",
                type: "bar",
                barWidth: "50%",
                data: [],
                label: {
                    show: true,
                    position: "top",
                    formatter: "{c}",
                    fontWeight: "bold",
                    fontSize: 15,
                    color: "#333"
                },
                itemStyle: {
                    borderRadius: [8, 8, 0, 0],
                    shadowBlur: 10,
                    shadowColor: "rgba(66, 133, 244, 0.4)"
                }
            }]
        },
        highestPassClass: "N/A",
        lowestPassClass: "N/A",
        option_class_pass: {
            title: {
                text: 'Class-wise % of Passing',
                left: 'center',
                top: 20,
                textStyle: { fontSize: 20, fontWeight: 'bold' }
            },
            tooltip: {
                trigger: 'axis',
                formatter: '{b}: {c}%'
            },
            grid: {
                top: 80,
                bottom: 80,
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: [],
                axisLabel: {
                    fontSize: 14,
                    fontWeight: 'bold',
                    color: '#333',
                    rotate: 0
                },
                name: 'Class',
                nameLocation: 'middle',
                nameGap: 40,
                nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
            },
            yAxis: {
                type: 'value',
                name: '% Passing',
                min: 0,
                max: 100,
                interval: 10,
                nameLocation: 'middle',
                nameGap: 60,
                nameTextStyle: { fontSize: 16, fontWeight: 'bold' },
                axisLabel: {
                    formatter: '{value}%'
                }
            },
            series: [{
                name: '% Passing',
                type: 'bar',
                barWidth: '50%',
                data: [],
                itemStyle: {
                    color: '#5470C6',
                    borderRadius: [8, 8, 0, 0]
                },
                label: {
                    show: true,
                    position: 'top',
                    fontSize: 18,
                    fontWeight: 'bold',
                    color: '#000',
                    formatter: '{c}%'
                }
            }]
        },
        option_grade_pass: {
    title: {
        text: 'Grade-wise % of Passing',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}: {c}%'
    },
    grid: {
        top: 80,
        bottom: 80,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold',
            color: '#333',
            rotate: 0
        },
        name: 'Grade',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: '% Passing',
        min: 0,
        max: 100,
        interval: 10,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' },
        axisLabel: {
            formatter: '{value}%'
        }
    },
    series: [{
        name: '% Passing',
        type: 'bar',
        barWidth: '50%',
        data: [],
        itemStyle: {
            color: '#5470C6',
            borderRadius: [8, 8, 0, 0]
        },
        label: {
            show: true,
            position: 'top',
            fontSize: 18,
            fontWeight: 'bold',
            color: '#000',
            formatter: '{c}%'
        }
    }]
},
highestGradePass: "N/A",
lowestGradePass: "N/A",
option_grade_pass: {
    title: {
        text: 'Grade-wise % of Passing',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}: {c}%'
    },
    grid: {
        top: 80,
        bottom: 80,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold',
            color: '#333',
            rotate: 0
        },
        name: 'Grade',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: '% Passing',
        min: 0,
        max: 100,
        interval: 10,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' },
        axisLabel: {
            formatter: '{value}%'
        }
    },
    series: [{
        name: '% Passing',
        type: 'bar',
        barWidth: '50%',
        data: [],
        itemStyle: {
            color: '#5470C6',
            borderRadius: [8, 8, 0, 0]
        },
        label: {
            show: true,
            position: 'top',
            fontSize: 18,
            fontWeight: 'bold',
            color: '#000',
            formatter: '{c}%'
        }
    }]
},
highestSubjectClass: "N/A",
lowestSubjectClass: "N/A",
option_subject_avg: {
    title: {
        text: 'Subjectwise Avg Marks',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}: {c} marks'
    },
    grid: {
        top: 80,
        bottom: 80,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold',
            color: '#333'
        },
        name: 'Class',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Marks',
        min: 0,
        max: 100,
        interval: 10,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    series: [{
        name: 'Avg Marks',
        type: 'bar',
        barWidth: '50%',
        data: [],
        itemStyle: {
            color: '#5470C6',
            borderRadius: [8, 8, 0, 0]
        },
        label: {
            show: true,
            position: 'top',
            fontSize: 18,
            fontWeight: 'bold',
            color: '#000',
            formatter: '{c}'
        }
    }]
},
highestClassTest: "N/A",
lowestClassTest: "N/A",
option_class_test_performance: {
    title: {
        text: 'Class Test - Grade-wise Performance',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}: {c} marks'
    },
    grid: {
        top: 80,
        bottom: 80,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold',
            color: '#333'
        },
        name: 'Grade',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Avg Marks',
        min: 0,
        max: 100,
        interval: 10,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    series: [{
        name: 'Avg Marks',
        type: 'bar',
        barWidth: '50%',
        data: [],
        itemStyle: {
            color: '#5470C6',
            borderRadius: [8, 8, 0, 0]
        },
        label: {
            show: true,
            position: 'top',
            fontSize: 18,
            fontWeight: 'bold',
            color: '#000',
            formatter: '{c}'
        }
    }]
},
mostCommonGrade: "N/A",
totalStudentsInDist: 0,
option_grade_distribution: {
    title: {
        text: 'Grade Distribution',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} students ({d}%)'
    },
    legend: {
        orient: 'vertical',
        left: 'left',
        top: 'middle',
        textStyle: { fontSize: 14 }
    },
    series: [{
        name: 'Students',
        type: 'pie',
        radius: '70%',                  // ← Changed from ['40%', '70%'] to '70%'
        center: ['50%', '50%'],         // ← Centered perfectly
        avoidLabelOverlap: false,
        itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 3              // Slightly thicker border for clean separation
        },
        label: {
            show: true,
            position: 'inside',
            fontSize: 20,               
            fontWeight: 'bold',
            color: '#fff',            
            formatter: '{c}'          
        },
        emphasis: {
            itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
            label: {
                show: true,
                fontSize: 24,
                fontWeight: 'bold'
            }
        },
        labelLine: { show: false },
        data: []  
    }]
},

bestCycle: "N/A",
totalCycles: 0,
option_cycle_comparison: {
    title: {
        text: 'Result Analysis',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}<br>{a}: {c} marks'
    },
    legend: {
        data: [],  // Will be filled: ['CY-1', 'CY-2', 'CY-3']
        bottom: 10
    },
    grid: {
        top: 80,
        bottom: 80,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],  // Grades
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold'
        },
        name: 'Grade',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Avg Marks %',
        min: 0,
        max: 100,
        interval: 20,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    series: []  // Will be filled dynamically with 3 series
},
option_cycle_comparison: {
    title: {
        text: 'Result Analysis',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}<br>{a}: {c} marks'
    },
    legend: {
        data: [],  // Will be filled: ['CY-1', 'CY-2', 'CY-3']
        bottom: 10
    },
    grid: {
        top: 80,
        bottom: 80,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],  // Grades
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold'
        },
        name: 'Grade',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Avg Marks %',
        min: 0,
        max: 100,
        interval: 20,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    series: []  // Will be filled dynamically with 3 series
},
overallBestGender: "N/A",
biggestGapGrade: "N/A",
option_gender_performance: {
    title: {
        text: 'Genderwise Performance',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
    },
    tooltip: {
        trigger: 'axis',
        formatter: '{b}<br>{a}: {c} marks'
    },
    legend: {
        data: ['Male', 'Female'],
        bottom: 10
    },
    grid: {
        top: 80,
        bottom: 80,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
            fontSize: 14,
            fontWeight: 'bold'
        },
        name: 'Grade',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    yAxis: {
        type: 'value',
        name: 'Avg Marks %',
        min: 0,
        max: 100,
        interval: 10,
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: { fontSize: 16, fontWeight: 'bold' }
    },
    series: [
        {
            name: 'Male',
            type: 'bar',
            barWidth: 35,
            itemStyle: { color: '#5470C6' },
            label: {
                show: true,
                position: 'top',
                fontSize: 16,
                fontWeight: 'bold',
                formatter: '{c}'
            },
            data: []
        },
        {
            name: 'Female',
            type: 'bar',
            barWidth: 35,
            itemStyle: { color: '#EE6666' },
            label: {
                show: true,
                position: 'top',
                fontSize: 16,
                fontWeight: 'bold',
                formatter: '{c}'
            },
            data: []
        }
    ]
},
selectedAppraisalAY: null,
    appraisalLoading: false,
    appraisalScores: [], // [{ay: "2020-21", percentage: 80, obtained: 1320, outOf: 1600}, ...]

    appraisalScoreChart: {
      title: {
        text: 'Appraisal Score',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
      },
      tooltip: {
        trigger: 'axis',
        formatter: (params) => {
          const p = params[0];
          return `${p.name}<br>Score: ${p.value}%`;
        //   return `${p.name}<br>Score: ${p.value}% <br>(${p.data.obtained}/${p.data.outOf})`;
        }
      },
      grid: {
        top: 100,
        bottom: 80,
        left: '10%',
        right: '10%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: [],
        name: 'Academic Year',
        nameLocation: 'middle',
        nameGap: 40,
        axisLabel: { fontSize: 14, fontWeight: 'bold', rotate: 0 }
      },
      yAxis: {
        type: 'value',
        name: 'Score %',
        min: 0,
        max: 100,
        interval: 5,
        axisLabel: { formatter: '{value}%' }
      },
      series: [{
        name: 'Score %',
        type: 'bar',
        barWidth: '45%',
        data: [],
        itemStyle: {
          color: '#3B82F6',
          borderRadius: [8, 8, 0, 0]
        },
        label: {
          show: true,
          position: 'top',
          fontSize: 16,
          fontWeight: 'bold',
          color: '#1E293B',
          formatter: (param) => {
    const percentage = param.data.percentage;
    // Only show if it's a real number
    if (percentage != null && !isNaN(percentage)) {
      return `${percentage}%`;
    }
    return '';  
  }
        }
      }]
    },
//         LeaveData: {
//     title: {
//         text: "Leave Distribution",
//         left: "center",
//         top: 10,
//         textStyle: { fontSize: 18, fontWeight: 'bold' }
//     },
//     // 🔥 New color palette applied here
//     color: ['#2563EB', '#F59E0B', '#EF4444', '#22C55E'], 
//     tooltip: {
//         trigger: "item",
//         formatter: '{a} <br/>{b}: <b>{c} Days</b> ({d}%)'
//     },
//     legend: {
//         bottom: 0,
//         left: "center",
//         icon: 'circle'
//     },
//     series: [
//         {
//             name: "Leave Type",
//             type: "pie",
//             radius: ["45%", "70%"], // Modern Donut look
//             avoidLabelOverlap: false,
//             itemStyle: {
//                 borderRadius: 8,
//                 borderColor: '#fff',
//                 borderWidth: 2
//             },
//             label: { show: false },
//             data: [], // Populated by your existing applyFilter() logic
//         },
//     ],
// },
selectedAy: null,
  ayList: [],
  ayLoading: false,
  loadingLeave: false,
  leaveDataLoaded: false,
  myLeaveAnalytics: [],           // array of { leaveType, total, inProgress, availed, balance }
  selectedAyName: '',
  snackbar: false,
  snackbarColor: 'success',       // default
  snackbarText: '',
// activeSubTab: 'overall',
//     selectedFeedbackAY: null,
//     ayList: [],                     // Reuse from Admission/Academics or populate separately
//     feedbackPerformanceData: [],    // [{ay: '2021-22', index: 78.5}, ...]
//     overallPerformanceAvg: 0,
//     feedbackLoading: false,

//     // Chart options
//     feedbackPerformanceChart: {
//         title: { text: 'Overall Feedback Analysis', left: 'center', top: 20 },
//         tooltip: { trigger: 'axis' },
//         grid: { top: 80, bottom: 100, containLabel: true },
//         xAxis: {
//             type: 'category',
//             data: [],
//             axisLabel: { rotate: 30, fontSize: 12 }
//         },
//         yAxis: {
//             type: 'value',
//             name: 'Performance Index',
//             min: 0,
//             max: 100,
//             interval: 10
//         },
//         series: [{
//             name: 'Performance Index',
//             type: 'bar',
//             data: [],
//             itemStyle: { color: '#3B82F6' },
//             label: { show: true, position: 'top', fontSize: 14, color: '#333' }
//         }]
//     },
//     activeFeedbackTab: 'overall',
//     feedbackAYList: [],               // Will be filled with ay strings
//     selectedFeedbackAY: null,
//     feedbackPerformanceData: [],      
//     overallPerformanceAvg: '0',
//     filteredIndex: null,
//     feedbackLoading: false,
//     overallFeedbackChart: {
//     backgroundColor: '#ffffff',
//     title: {
//       text: 'Overall Feedback Analysis',
//       left: 'center',
//       top: 20,
//       textStyle: { fontSize: 20, fontWeight: 'bold' }
//     },
//     tooltip: { trigger: 'axis', formatter: '{b}<br>Index: {c}' },
//     grid: { top: 80, bottom: 100, containLabel: true },
//     xAxis: {
//       type: 'category',
//       data: [],
//       axisLabel: { rotate: 45, fontSize: 12 }
//     },
//     yAxis: {
//       type: 'value',
//       name: 'Performance Index',
//       min: 0,
//       max: 100,
//       interval: 10
//     },
//     series: [{
//       name: 'Performance Index',
//       type: 'bar',
//       data: [],
//       itemStyle: { color: '#3B82F6' },
//       label: { show: true, position: 'top', fontSize: 14 }
//     }]
//   },
  // Transport
  transportLoading: false,
  selectedTransportAY: null,
  selectedTransportStandard: null,
  transportClasses: [],
  schoolBusCounts: [],
  parentPickupCounts: [],
  selfCounts: [],
  totalTransportStudents: 0,
  highestSchoolBusClass: "N/A",

  transport_classwise_horizontal: {
  title: {
    text: 'Transport – Class-wise Analysis',
    left: 'center',
    top: 15,
    textStyle: { fontSize: 20, fontWeight: 'bold' }
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: { type: 'shadow' },
    formatter: (params) => {
      let str = params[0].name + '<br/>';
      params.forEach(p => {
        if (p.value > 0) {
          str += `${p.marker} ${p.seriesName}: ${p.value}<br/>`;
        }
      });
      return str;
    }
  },
  legend: {
    data: ['School Bus', 'Parent Pick-up', 'Self'],
    bottom: 10,
    itemGap: 24,
    textStyle: { fontSize: 13 }
  },
  grid: {
    left: '26%',          // ← more space for long class names
    right: '5%',
    top: 80,
    bottom: 80,
    containLabel: true    // ← very important – prevents label cutoff
  },
  xAxis: {
    type: 'value',
    name: 'Number of Students',
    nameLocation: 'middle',
    nameGap: 35,
    min: 0,
    axisLabel: { fontSize: 12 },
    splitLine: { lineStyle: { type: 'dashed' } }
  },
  yAxis: {
    type: 'category',
    name: 'Class / Division',
    nameLocation: 'middle',
    nameGap: 140,
    inverse: true,               // ← top = first class (most readable)
    data: [],                    // filled in fetchTransportData
    axisLabel: {
      interval: 0,               // show ALL labels
      fontSize: 13,
      align: 'right',
      margin: 12,
      width: 260,                // ← wider space for long names like XII (Comm) Sci B
      overflow: 'truncate',      // or try 'breakAll' / 'break'
      formatter: (value) => {
        // Optional: force line break on very long names
        if (value.length > 32) {
          return value.replace(/(.{28})/g, '$1\n');
        }
        return value;
      }
    },
    axisTick: { alignWithLabel: true }
  },
  series: [
    {
      name: 'School Bus',
      type: 'bar',
      barWidth: 10,                // ← thinner bars = better for many rows
      barCategoryGap: '45%',       // ← vertical spacing between classes
      barGap: '25%',               // ← spacing between the 3 bars in one row
      data: [],
      label: {
        show: true,
        position: 'right',
        distance: 6,
        fontSize: 12,
        fontWeight: 'bold',
        formatter: '{c}'
      },
      itemStyle: {
        color: '#3B82F6',
        borderRadius: [0, 6, 6, 0]
      }
    },
    {
      name: 'Parent Pick-up',
      type: 'bar',
      barWidth: 10,
      barCategoryGap: '45%',
      barGap: '25%',
      data: [],
      label: {
        show: true,
        position: 'right',
        distance: 6,
        fontSize: 12,
        fontWeight: 'bold',
        formatter: '{c}'
      },
      itemStyle: {
        color: '#F59E0B',
        borderRadius: [0, 6, 6, 0]
      }
    },
    {
      name: 'Self',
      type: 'bar',
      barWidth: 10,
      barCategoryGap: '45%',
      barGap: '25%',
      data: [],
      label: {
        show: true,
        position: 'right',
        distance: 6,
        fontSize: 12,
        fontWeight: 'bold',
        formatter: '{c}'
      },
      itemStyle: {
        color: '#10B981',
        borderRadius: [0, 6, 6, 0]
      }
    }
  ]
},
grade_wise_transport_data: [],
    grade_wise_transport_options: {
      title: {
        text: 'Transport - Option Grade-wise Analysis',
        left: 'center',
        top: 20,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: (params) => {
          let str = params[0].name + '<br/>';
          params.forEach(p => {
            if (p.value > 0) {
              str += `${p.marker} ${p.seriesName}: ${p.value}<br/>`;
            }
          });
          return str;
        }
      },
      legend: {
        data: ['School Transport', 'Parent Pickup-Drop', 'Self'],
        bottom: 10,
        itemGap: 20
      },
      grid: {
        left: '8%',
        right: '8%',
        top: 80,
        bottom: 80,
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: [],
        name: 'Grade',
        nameLocation: 'middle',
        nameGap: 40,
        axisLabel: {
          fontSize: 14,
          fontWeight: 'bold',
          rotate: 0
        }
      },
      yAxis: {
        type: 'value',
        name: 'Number of Students',
        nameLocation: 'middle',
        nameGap: 50,
        min: 0,
        axisLabel: { fontSize: 12 }
      },
      series: [
        {
          name: 'School Transport',
          type: 'bar',
          barWidth: '35%',
          itemStyle: { color: '#3B82F6' },
          label: { show: true, position: 'top', fontSize: 13 },
          data: []
        },
        {
          name: 'Parent Pickup-Drop',
          type: 'bar',
          barWidth: '35%',
          itemStyle: { color: '#F59E0B' },
          label: { show: true, position: 'top', fontSize: 13 },
          data: []
        },
        {
          name: 'Self',
          type: 'bar',
          barWidth: '35%',
          itemStyle: { color: '#10B981' },
          label: { show: true, position: 'top', fontSize: 13 },
          data: []
        }
      ]
    },
    standardWiseDues: [],           // from API: [{standardName: "Grade I", dueCollection: 23}, ...]
    totalFeesDue: 0,

    // Horizontal scrollable chart for Fees Due
    fees_due_horizontal: {
  title: {
    text: 'Class-wise Fees Dues',
    left: 'center',
    top: 15,
    textStyle: { fontSize: 20, fontWeight: 'bold' }
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: { type: 'shadow' },
    formatter: function(params) {
      let result = params[0].name + '<br/>';
      params.forEach(p => {
        if (p.value > 0) {
          result += `${p.marker} Fees Due: ${p.value.toFixed(2)} Lakhs<br/>`;
        }
      });
      return result || params[0].name + '<br/>No dues';
    }
  },
  grid: {
    left: '22%',          // Space for long class/grade names
    right: '10%',
    top: 80,
    bottom: 70,
    containLabel: true
  },
  xAxis: {
    type: 'value',
    name: 'Amount in Lakhs Rs.',
    nameLocation: 'middle',
    nameGap: 40,
    min: 0,
    axisLabel: {
      fontSize: 12,
      formatter: '{value} L'
    },
    splitLine: { show: true, lineStyle: { type: 'dashed' } }
  },
  yAxis: {
    type: 'category',
    name: 'Class / Grade',
    nameLocation: 'middle',
    nameGap: 140,
    inverse: true,                // Newest/highest at top
    data: [],
    axisLabel: {
      interval: 0,
      fontSize: 13,
      width: 260,
      overflow: 'truncate',
      align: 'right',
      formatter: function(value) {
        return value.length > 28 ? value.match(/.{1,28}/g).join('\n') : value;
      }
    },
    axisTick: { alignWithLabel: true }
  },
  series: [
    {
      name: 'Fees Due in Lakhs',
      type: 'bar',
      barWidth: 12,
      barCategoryGap: '50%',
      data: [],
      label: {
        show: true,
        position: 'right',
        fontSize: 12,
        fontWeight: 'bold',
        color: '#ef4444',
        formatter: '{c} L'
      },
      itemStyle: {
        color: '#ef4444',          // Red like your reference
        borderRadius: [0, 6, 6, 0]
      }
    }
  ]
},
paymentStatsByStandard: [],   // from API: [{standardName: "Grade I", onTimeCount: 23, lateCount: 7}, ...]
    totalOnTime: 0,
    totalLate: 0,

    payment_stats_horizontal: {
      title: {
        text: 'Payment on Time Vs Late Payment',
        left: 'center',
        top: 15,
        textStyle: { fontSize: 20, fontWeight: 'bold' }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: function(params) {
          let result = params[0].name + '<br/>';
          params.forEach(p => {
            if (p.value > 0) {
              result += `${p.marker} ${p.seriesName}: ${p.value}<br/>`;
            }
          });
          return result || params[0].name + '<br/>No payments';
        }
      },
      legend: {
        data: ['Paid on Time', 'Late Payments'],
        bottom: 10,
        itemGap: 20
      },
      grid: {
        left: '22%',
        right: '10%',
        top: 80,
        bottom: 70,
        containLabel: true
      },
      xAxis: {
        type: 'value',
        name: 'Number of Students',
        nameLocation: 'middle',
        nameGap: 40,
        min: 0,
        axisLabel: { fontSize: 12 }
      },
      yAxis: {
        type: 'category',
        name: 'Class / Grade',
        nameLocation: 'middle',
        nameGap: 140,
        inverse: true,
        data: [],
        axisLabel: {
          interval: 0,
          fontSize: 13,
          width: 260,
          overflow: 'truncate',
          align: 'right',
          formatter: function(value) {
            return value.length > 28 ? value.match(/.{1,28}/g).join('\n') : value;
          }
        },
        axisTick: { alignWithLabel: true }
      },
      series: [
        {
          name: 'Paid on Time',
          type: 'bar',
          barWidth: 12,
          barCategoryGap: '50%',
          data: [],
          label: {
            show: true,
            position: 'right',
            fontSize: 12,
            fontWeight: 'bold',
            color: '#3b82f6',
            formatter: '{c}'
          },
          itemStyle: {
            color: '#3b82f6',   // blue
            borderRadius: [0, 6, 6, 0]
          }
        },
        {
          name: 'Late Payments',
          type: 'bar',
          barWidth: 12,
          barCategoryGap: '50%',
          data: [],
          label: {
            show: true,
            position: 'right',
            fontSize: 12,
            fontWeight: 'bold',
            color: '#f59e0b',
            formatter: '{c}'
          },
          itemStyle: {
            color: '#f59e0b',   // orange
            borderRadius: [0, 6, 6, 0]
          }
        }
      ]
    },
       // homework_overall option
homework_overall: {
    title: { text: "Overall Assignment Analysis", left: "center" },
    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    /* Restoration of the switch logic */
    toolbox: {
        show: true,
        feature: {
            magicType: { show: true, type: ["line", "bar", "stack"] },
            restore: { show: true },
            saveAsImage: { show: true },
        },
    },
    grid: { top: "20%", bottom: "20%", containLabel: true },
    xAxis: { type: "category", data: [], axisLabel: { rotate: 45 } },
    yAxis: { type: "value", name: "Homeworks" },
    series: [
        {
            name: "Total Submissions",
            type: "bar",
            itemStyle: {
                borderRadius: [5, 5, 0, 0],
                color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#6366F1' }, { offset: 1, color: '#4338CA' }] }
            },
            data: [],
        },
        {
            name: "Total Homeworks",
            type: "bar",
            itemStyle: {
                borderRadius: [5, 5, 0, 0],
                color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#F87171' }, { offset: 1, color: '#B91C1C' }] }
            },
            data: [],
        },
    ],
},

// homework_byAy option (Matches the logic of the filtered graph)
homework_byAy: {
    title: { 
        text: "Coursewise Assignment Analysis", 
        left: "center",
        textStyle: { fontSize: 18, fontWeight: 'bold' }
    },
    // Adding the legend to identify Green/Orange (Submissions/Homeworks)
    legend: {
        show: true,
        data: ["Total Submissions", "Total Homeworks"],
        bottom: 10
    },
    // FIX: This enables the hover data box
    tooltip: { 
        show: true,
        trigger: "axis", // Activates tooltip when hovering near bars
        axisPointer: { 
            type: "shadow" // Adds the gray highlight behind the bars
        },
        backgroundColor: "rgba(30,41,59,0.95)", // Professional dark background
        textStyle: { color: "#FFFFFF" },
        formatter: "{b}<br/>{a0}: <b>{c0}</b><br/>{a1}: <b>{c1}</b>" // Clear labeling
    },
    toolbox: {
        show: true,
        feature: {
            magicType: { show: true, type: ["line", "bar", "stack"] },
            restore: { show: true },
            saveAsImage: { show: true },
        },
    },
    grid: { top: "15%", bottom: "15%", containLabel: true },
    xAxis: { 
        type: "category", 
        data: [], 
        axisLabel: { rotate: 0, fontWeight: 'bold' } 
    },
    yAxis: { type: "value", name: "Homeworks" },
    series: [
        {
            name: "Total Submissions",
            type: "bar",
            barWidth: '30%',
            label: { show: true, position: 'top', fontWeight: 'bold' }, // Numbers on top
            itemStyle: {
                borderRadius: [5, 5, 0, 0],
                color: { 
                    type: 'linear', x: 0, y: 0, x2: 0, y2: 1, 
                    colorStops: [{ offset: 0, color: '#6366F1' }, { offset: 1, color: '#4338CA' }] 
                }
            },
            data: [],
        },
        {
            name: "Total Homeworks",
            type: "bar",
            barWidth: '30%',
            label: { show: true, position: 'top', fontWeight: 'bold' }, // Numbers on top
            itemStyle: {
                borderRadius: [5, 5, 0, 0],
                color: { 
                    type: 'linear', x: 0, y: 0, x2: 0, y2: 1, 
                    colorStops: [{ offset: 0, color: '#F87171' }, { offset: 1, color: '#B91C1C' }] 
                }
            },
            data: [],
        },
    ],
},
        quiz_overall: {
            title: {
                text: "Overall Quiz Analysis",
                left: "center",
            },
            color: ["#ff6d00", "#ffb600"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                },
            },
            calculable: true,
            legend: {
                data: ["Cumm. Avg Total Marks", "Cumm. Avg Obtained Marks"],
                itemGap: 15,
                bottom: 0,
            },
            grid: {
                top: "20%",
                bottom: "20%",
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 45,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "",
                nameLocation: "end",
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Marks",
                nameLocation: "end",
                offset: 10,
            },
            series: [
                {
                    name: "Cumm. Avg Total Marks",
                    data: [],
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                    },
                },
                {
                    name: "Cumm. Avg Obtained Marks",
                    data: [],
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                    },
                },
            ],
        },
        quiz_byAy: {
            title: {
                text: "Coursewise Quiz Analysis",
                left: "center",
            },
            color: ["#005b9f", "#e53935"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                },
            },
            calculable: true,
            legend: {
                data: ["Total Marks", "Avg Obtained Marks"],
                itemGap: 15,
                bottom: 0,
            },
            grid: {
                top: "20%",
                bottom: "20%",
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 45,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "",
                nameLocation: "end",
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Marks",
                nameLocation: "end",
                offset: 10,
            },
            series: [
                {
                    name: "Total Marks",
                    data: [],
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                    },
                },
                {
                    name: "Avg Obtained Marks",
                    data: [],
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                    },
                },
            ],
        },
    }),
    components: {
        epsHeader: epsHeader,
    },
    computed: {
  filteredLeaveTypes() {
    return (this.myLeaveAnalytics || []).filter(lt =>
      Number(lt.total) > 0 ||
      Number(lt.inProgress) > 0 ||
      Number(lt.availed) > 0 ||
      Number(lt.balance) > 0
    )
  },
},
    watch: {
    selectedModule(newVal) {
            if (newVal === 'Transport') {
                this.loadTransportFilters(); // Separate loader for Transport
            } else if (newVal === 'Admission' || newVal === 'Academics') {
                this.loadAYAndStandards();
            } else if (newVal === 'Leave' || newVal === 'Appraisal') {
                this.loadAYAndStandards();
            }
        }
},
    methods: {
    selectSubTab(tab) {
    this.activeSubTab = tab;
    if (tab === "overall_hw") {
        this.getInstHomeworkData(); // Trigger the overall fetch automatically
    }
    // this.activeFeedbackTab = tab;
    // if (tab === 'overall' || tab === 'filter') {
    //   if (!this.feedbackPerformanceData.length) {
    //     this.fetchFeedbackPerformance()
    //   }
    // }
},    
    selectSubTab(tab) {
        this.activeSubTab = tab;
        if (tab === "overall") {
            this.getInstAttendanceData();
            // this.fetchFeedbackPerformance()
        } else {
            this.showFilters();
        }
    },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        showFilters() {
            this.filtered = true;
            this.overall = false;


            if (this.selectedModule == "Profile") {
                this.profile = true;
            } else if (this.selectedModule == "Quiz") {
                this.quiz = true;
            } else if (this.selectedModule == "Homework") {
                this.homework = true;
            // } else if (this.selectedModule == "Feedback") {
            //     this.feedback = true;
            } else if (this.selectedModule == "Biometric") {
                this.biometric = true;
            } else if (this.selectedModule == "Appraisal") {
                this.appraisal = true;
            } else if (this.selectedModule == "Result") {
                this.result = true;
            } else if (this.selectedModule == "Registration") {
                this.registration = true;
            } else if (this.selectedModule == "Leave") {
                this.leave = true;
            }
        },
        showFilters_profile() {
            if (this.activeTab == 'Publication') {
                this.profile_filtered_publications = true;
                this.profile_overall = false;
            }
            else if (this.activeTab == 'Training') {
                this.profile_filtered_trainings = true;
                this.profile_overall_2 = false;
            }
            else if (this.activeTab == 'Activity') {
                this.profile_filtered_activities = true;
                this.profile_overall_3 = false;
            }
        },
        updateTitle(moduleName) {
            this.overall = false;
            this.filtered = false;
            this.showGraph = false;

            this.appraisal = false;
            this.profile = false;
            this.quiz = false;
            this.homework = false;
            // this.feedback = false;
            this.biometric = false;
            this.result = false;
            this.registration = false;

            if (moduleName == "Profile") {
                this.profile = true;
            } else if (moduleName == "Quiz") {
                this.quiz = true;
            } else if (moduleName == "Homework") {
                this.homework = true;
            // } else if (moduleName == "Feedback") {
            //     this.feedback = true;
            } else if (moduleName == "Biometric") {
                this.biometric = true;
            } else if (moduleName == "Appraisal") {
                this.appraisal = true;
            } else if (moduleName == "Result") {
                this.result = true;
            } else if (moduleName == "Registration") {
                this.registration = true;
            } else if (moduleName == "Leave") {
                this.leave = true;
            } else if (moduleName === 'Admission') {
        this.admission = true;
        this.loadAYAndStandards();  
    }
    else if (moduleName === 'Academics') {
    this.academics = true;
    this.loadAYAndStandards(); 
}
            this.selectedModule = moduleName;
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
            this.onLoad();
            this.resetTabs();
        },
        resetTabs() {
            this.overall = false;
            this.bar_graph_details == '';
            this.CourseDetails = false;
            this.showInfo = false;
            this.getInstructorAttendanceAnalyticsByAy_fetch = false;
            this.profile_overall = false;
            this.profile_overall_2 = false;
            this.profile_overall_3 = false;
            this.getInstructoPublicationAnalyticsByAy_fetch = false;
            this.getInstructoPublicationAnalyticsByAy_fetch_2 = false;
            this.getInstructoTrainingAnalyticsByAy_fetch_2 = false;
            this.getInstructoTrainingAnalyticsByAy_fetch = false;
            this.getInstructoTActivityAnalyticsByAy_fetch_2 = false;
            this.getInstructoTActivityAnalyticsByAy_fetch = false;
            this.profile_filtered_activities = false;
            this.profile_filtered_publications = false;
            this.profile_filtered_trainings = false;
            this.academicsSubView = 'syllabus';
this.syllabusClasses = [];
this.syllabusPercentages = [];
this.highestSyllabusClass = "N/A";
this.lowestSyllabusClass = "N/A";
        },
        async loadAYAndStandards() {
    try {
        const res = await axios.post("/Analytics/getInstCourseOffDetails"); // Reuse existing API
        if (res.data.flag === "YES") {
            this.ayList = res.data.ay_list || [];
           this.standardList = res.data.standard_list.map(std => ({
    id: std.id,
    std_name: std.std_name
}));
            // Set default: current active AY
            const activeAY = this.ayList.find(ay => ay.isactive);
            this.selectedAY = activeAY ? activeAY.id : (this.ayList[0].id || null);

            // Default standard
            this.selectedStandard = this.standardList[0].id || null;

            if (this.selectedAY && this.selectedStandard) {
                this.fetchAdmissionData();
            }
        }
    } catch (err) {
        this.showSnackbar("#b71c1c", "Failed to load filters");
    }
},
        // async fetchFeedbackPerformance() {
        //     this.feedbackLoading = true

        //     try {
        //         const payload = this.selectedFeedbackAY
        //             ? { selected_ay: this.selectedFeedbackAY }
        //             : {}

        //         const res = await axios.post('/Analytics/getInstructorFeedbackPerformanceIndex', payload)

        //         if (res.data.flag === 'YES') {
        //             const data = res.data.performance_data || []

        //             // For overall chart (all years)
        //             this.feedbackPerformanceData = data
        //             this.feedbackPerformanceChart.xAxis.data = data.map(item => item.ay)
        //             this.feedbackPerformanceChart.series[0].data = data.map(item => item.index)
        //             this.overallPerformanceAvg = res.data.overall_avg.toFixed(0) || 0
        //             this.overallFeedbackChart.xAxis.data = data.map(d => d.ay)
        //             this.overallFeedbackChart.series[0].data = data.map(d => d.index)
        //             this.overallPerformanceAvg = res.data.overall_avg.toFixed(2) || '0'
        //             // For filtered view (single year)
        //             if (this.selectedFeedbackAY) {
        //                 const selectedData = data.find(d => d.ay === this.selectedFeedbackAY.ay)
        //                 this.filteredFeedbackChart = {
        //                     ...this.feedbackPerformanceChart,
        //                     title: { text: `Performance - ${selectedData.ay || 'Selected Year'}`, left: 'center' },
        //                     xAxis: { data: [selectedData.ay || 'N/A'] },
        //                     series: [{ data: [selectedData.index || 0] }]
        //                 }
        //             }
        //         } else {
        //             this.showSnackbar('#b71c1c', res.data.msg || 'No feedback data found')
        //         }
        //     } catch (err) {
        //         console.error(err)
        //         this.showSnackbar('#b71c1c', 'Failed to load performance index')
        //     } finally {
        //         this.feedbackLoading = false
        //     }
        // },
        // updateFilteredChart() {
        //     if (!this.selectedFeedbackAY) {
        //         this.filteredIndex = null
        //         return
        //     }

        //     const item = this.feedbackPerformanceData.find(d => d.ay === this.selectedFeedbackAY)
        //     if (item) {
        //         this.filteredIndex = item.index
        //         this.filteredFeedbackChart = {
        //             backgroundColor: '#ffffff',
        //             title: {
        //                 text: `Performance - ${this.selectedFeedbackAY}`,
        //                 left: 'center',
        //                 top: 20,
        //                 textStyle: { fontSize: 20, fontWeight: 'bold' }
        //             },
        //             tooltip: { trigger: 'item' },
        //             grid: { top: 80, bottom: 80, containLabel: true },
        //             xAxis: { type: 'category', data: [this.selectedFeedbackAY] },
        //             yAxis: { type: 'value', name: 'Performance Index', max: 100 },
        //             series: [{
        //                 name: 'Performance Index',
        //                 type: 'bar',
        //                 data: [item.index],
        //                 itemStyle: { color: '#10B981' },
        //                 label: { show: true, position: 'top', fontSize: 24 }
        //             }]
        //         }
        //     } else {
        //         this.filteredIndex = null
        //     }
        // },
        
          async loadTransportFilters() {
            try {
                const res = await axios.post("/Analytics/getInstCourseOffDetails");
                if (res.data.flag === "YES") {
                    this.ayList = res.data.ay_list || [];
                    this.standardList = res.data.standard_list.map(std => {
                        const stdId = std.id || std.std_id || std.standardId;
                        const stdName = std.std_name || std.standard || std.name;
                        return {
                            id: stdId,
                            std_name: stdName
                        };
                    });
                    this.selectedTransportAY = null;       
                    this.selectedTransportStandard = null;  
                }
            } catch (err) {
                console.error("Transport filter load error:", err);
                this.showSnackbar("error", "Failed to load transport filters");
            }
        },

        async fetchTransportData() {
            // if (!this.selectedTransportAY || !this.selectedTransportStandard) {
            //     this.showSnackbar("warning", "Please select both Academic Year and Standard");
            //     return;
            // }

            const ayId = Number(this.selectedTransportAY);
            const stdId = Number(this.selectedTransportStandard);
            if (isNaN(ayId) || isNaN(stdId)) {
                // console.error("Invalid ID conversion!");
                this.showSnackbar("error", "Invalid filter selection");
                return;
            }

            this.transportLoading = true;

            try {
                const payload = {
                    academicyearId: ayId,
                    standardIds: [stdId]
                };
                const res = await axios.post("/Analytics/getTransportAnalytics", payload);

                if (res.data.flag === "YES") {
                    // 1. Class-wise Data
                    let classData = res.data.class_wise_transport_data || [];

                    if (classData.length === 0) {
                        // console.warn("⚠️ No class-wise data returned for selected standard");
                        this.resetTransportChart();
                        return;
                    }

                    classData = [...classData].sort((a, b) =>
                        a.standardDivision.localeCompare(b.standardDivision, undefined, {
                            numeric: true,
                            sensitivity: "base"
                        })
                    );

                    this.transportClasses = classData.map(item => item.standardDivision);

                    // Update horizontal chart
                    this.transport_classwise_horizontal.yAxis.data = this.transportClasses;
                    this.transport_classwise_horizontal.series[0].data = classData.map(item => item.schoolBus || 0);
                    this.transport_classwise_horizontal.series[1].data = classData.map(item => item.parentPick || 0);
                    this.transport_classwise_horizontal.series[2].data = classData.map(item => item.self || 0);

                    // console.log("✅ Chart updated:", {
                    //     divisions: this.transportClasses,
                    //     schoolBus: this.transport_classwise_horizontal.series[0].data,
                    //     parentPick: this.transport_classwise_horizontal.series[1].data,
                    //     self: this.transport_classwise_horizontal.series[2].data
                    // });

                    // Calculate totals
                    this.totalTransportStudents =
                        this.transport_classwise_horizontal.series[0].data.reduce((a, b) => a + b, 0) +
                        this.transport_classwise_horizontal.series[1].data.reduce((a, b) => a + b, 0) +
                        this.transport_classwise_horizontal.series[2].data.reduce((a, b) => a + b, 0);

                    // Highest school bus class
                    const schoolBusData = this.transport_classwise_horizontal.series[0].data;
                    if (schoolBusData.length > 0) {
                        const maxVal = Math.max(...schoolBusData);
                        const idx = schoolBusData.indexOf(maxVal);
                        this.highestSchoolBusClass = maxVal > 0
                            ? `${this.transportClasses[idx]} (${maxVal})`
                            : "N/A";
                    }

                    // 2. Grade-wise Data
                    this.grade_wise_transport_data = res.data.grade_wise_transport_data || [];
                    if (this.grade_wise_transport_data.length > 0) {
                        this.grade_wise_transport_data.sort((a, b) =>
                            a.standardName.localeCompare(b.standardName, undefined, { numeric: true })
                        );
                        this.grade_wise_transport_options.xAxis.data = this.grade_wise_transport_data.map(g => g.standardName);
                        this.grade_wise_transport_options.series[0].data = this.grade_wise_transport_data.map(g => g.school_transport);
                        this.grade_wise_transport_options.series[1].data = this.grade_wise_transport_data.map(g => g.parent_pickup);
                        this.grade_wise_transport_options.series[2].data = this.grade_wise_transport_data.map(g => g.self);
                    }

                    // 3. Fees Due
                    let duesData = res.data.standardWiseDues || [];
                    duesData = [...duesData].sort((a, b) =>
                        a.standardName.localeCompare(b.standardName, undefined, { numeric: true })
                    );
                    this.standardWiseDues = duesData;
                    this.fees_due_horizontal.yAxis.data = duesData.map(d => d.standardName);
                    this.fees_due_horizontal.series[0].data = duesData.map(d => d.dueCollection || 0);
                    this.totalFeesDue = duesData.reduce((sum, item) => sum + (item.dueCollection || 0), 0);

                    // 4. Payment Stats
                    this.paymentStatsByStandard = res.data.paymentStatsByStandard || [];
                    this.paymentStatsByStandard.sort((a, b) =>
                        a.standardName.localeCompare(b.standardName, undefined, { numeric: true })
                    );
                    this.payment_stats_horizontal.yAxis.data = this.paymentStatsByStandard.map(p => p.standardName);
                    this.payment_stats_horizontal.series[0].data = this.paymentStatsByStandard.map(p => p.onTimeCount || 0);
                    this.payment_stats_horizontal.series[1].data = this.paymentStatsByStandard.map(p => p.lateCount || 0);
                    this.totalOnTime = this.paymentStatsByStandard.reduce((sum, p) => sum + (p.onTimeCount || 0), 0);
                    this.totalLate = this.paymentStatsByStandard.reduce((sum, p) => sum + (p.lateCount || 0), 0);

                    this.showSnackbar("success", "Transport data loaded successfully");

                } else {
                    this.resetTransportChart();
                    this.showSnackbar("error", res.data.msg || "No transport data found");
                }
            } catch (err) {
                console.error("Transport fetch error:", err);
                this.showSnackbar("error", "Failed to load transport analytics");
                this.resetTransportChart();
            } finally {
                this.transportLoading = false;
            }
        },

        resetTransportChart() {
            this.transportClasses = [];
            this.totalTransportStudents = 0;
            this.highestSchoolBusClass = "N/A";
            this.transport_classwise_horizontal.yAxis.data = [];
            this.transport_classwise_horizontal.series.forEach(s => s.data = []);
            this.grade_wise_transport_data = [];
            this.grade_wise_transport_options.xAxis.data = [];
            this.grade_wise_transport_options.series.forEach(s => s.data = []);
            this.standardWiseDues = [];
            this.totalFeesDue = 0;
            this.fees_due_horizontal.yAxis.data = [];
            this.fees_due_horizontal.series.forEach(s => s.data = []);
            this.paymentStatsByStandard = [];
            this.totalOnTime = 0;
            this.totalLate = 0;
            this.payment_stats_horizontal.yAxis.data = [];
            this.payment_stats_horizontal.series.forEach(s => s.data = []);
        },

async fetchAppraisalData() {
    this.appraisalLoading = true;
    try {
      const payload = {
        selected_ay: this.selectedAppraisalAY || null
      };
      const res = await axios.post("/Analytics/getAppraisalAnalytics", payload);
      
      if (res.data.flag === "YES") {
        this.appraisalScores = res.data.appraisal_scores || [];
        
        // Update chart
        this.appraisalScoreChart.xAxis.data = this.appraisalScores.map(item => item.ay);
        this.appraisalScoreChart.series[0].data = this.appraisalScores.map(item => ({
          value: item.percentage,
          obtained: item.obtained,
          outOf: item.outOf
        }));
      } else {
        this.appraisalScores = [];
        this.showSnackbar("error", res.data.msg || "No appraisal data found");
      }
    } catch (err) {
      console.error(err);
      this.showSnackbar("error", "Failed to load appraisal scores");
    } finally {
      this.appraisalLoading = false;
    }
  },
async fetchAdmissionData() {
    if (!this.selectedAY || !this.selectedStandard) return;

    const data = {
        selected_ay: this.selectedAY,
        selected_standard: this.selectedStandard
    };

    try {
        const res = await axios.post("/Analytics/getInstAdmissionCountAnalytics", data);

        if (res.data.flag === "YES") {
            // === 1. Number of Admissions Graph ===
            if (res.data.admission_count_data) {
                const raw = res.data.admission_count_data;

                this.admissionClasses = raw.map(item => item.division || "Unknown");
                this.admissionCounts = raw.map(item => item.count);

                this.option_admission_count.xAxis.data = this.admissionClasses;
                this.option_admission_count.series[0].data = this.admissionCounts;

                // Stats for count graph
                const total = this.admissionCounts.reduce((a, b) => a + b, 0);
                this.totalAdmissions = total;

                if (this.admissionCounts.length > 0) {
                    const max = Math.max(...this.admissionCounts);
                    const idx = this.admissionCounts.indexOf(max);
                    this.highestAdmissionClass = `${this.admissionClasses[idx]} (${max} students)`;
                } else {
                    this.highestAdmissionClass = "N/A";
                }
            } else {
                this.admissionClasses = [];
                this.admissionCounts = [];
                this.option_admission_count.xAxis.data = [];
                this.option_admission_count.series[0].data = [];
                this.totalAdmissions = 0;
                this.highestAdmissionClass = "N/A";
            }

            // === 2. Gender Ratio Graph ===
            if (res.data.admission_gender_ratio) {
                const genderRaw = res.data.admission_gender_ratio;

                this.genderClasses = genderRaw.map(item => item.division || "Unknown");
                this.maleAdmissions = genderRaw.map(item => item.male || 0);
                this.femaleAdmissions = genderRaw.map(item => item.female || 0);

                this.option_admission_gender.xAxis.data = this.genderClasses;
                this.option_admission_gender.series[0].data = this.maleAdmissions;   // Male
                this.option_admission_gender.series[1].data = this.femaleAdmissions; // Female

                // Most male/female dominant class
                let maxMaleDiff = 0, maxFemaleDiff = 0;
                let maleClass = "N/A", femaleClass = "N/A";

                genderRaw.forEach(item => {
                    const diff = (item.male || 0) - (item.female || 0);
                    if (diff > maxMaleDiff) {
                        maxMaleDiff = diff;
                        maleClass = `${item.division} (+${diff} Male)`;
                    }
                    if (-diff > maxFemaleDiff) {
                        maxFemaleDiff = -diff;
                        femaleClass = `${item.division} (+${maxFemaleDiff} Female)`;
                    }
                });

                this.mostMaleClass = maleClass;
                this.mostFemaleClass = femaleClass;
            } else {
                this.genderClasses = [];
                this.maleAdmissions = [];
                this.femaleAdmissions = [];
                this.option_admission_gender.xAxis.data = [];
                this.option_admission_gender.series[0].data = [];
                this.option_admission_gender.series[1].data = [];
                this.mostMaleClass = "N/A";
                this.mostFemaleClass = "N/A";
            }
        } else {
            // Reset both graphs if flag not YES
            this.admissionClasses = [];
            this.admissionCounts = [];
            this.genderClasses = [];
            this.maleAdmissions = [];
            this.femaleAdmissions = [];

            this.option_admission_count.xAxis.data = [];
            this.option_admission_count.series[0].data = [];
            this.option_admission_gender.xAxis.data = [];
            this.option_admission_gender.series[0].data = [];
            this.option_admission_gender.series[1].data = [];

            this.totalAdmissions = 0;
            this.highestAdmissionClass = "N/A";
            this.mostMaleClass = "N/A";
            this.mostFemaleClass = "N/A";

            this.showSnackbar("#b71c1c", res.data.msg || "No data found");
        }
        // === 3. Overall Gender Distribution Pie Chart ===
if (res.data.admission_gender_ratio) {
    let totalMaleCount = 0;
    let totalFemaleCount = 0;

    res.data.admission_gender_ratio.forEach(item => {
        totalMaleCount += item.male || 0;
        totalFemaleCount += item.female || 0;
    });

    const grandTotal = totalMaleCount + totalFemaleCount;

    this.totalMale = totalMaleCount;
    this.totalFemale = totalFemaleCount;

    if (grandTotal > 0) {
        this.overallGenderData = [
            {
                value: totalMaleCount,
                name: 'Male',
                itemStyle: { color: '#5470C6' }
            },
            {
                value: totalFemaleCount,
                name: 'Female',
                itemStyle: { color: '#EE6666' }
            }
        ];

        this.option_overall_gender.series[0].data = this.overallGenderData;

        // Custom legend with counts
        this.option_overall_gender.legend.formatter = function(name) {
            const item = this.overallGenderData.find(d => d.name === name);
            return `${name} # ${item ? item.value : 0}`;
        }.bind(this);
    } else {
        this.overallGenderData = [];
        this.option_overall_gender.series[0].data = [];
    }
} else {
    this.overallGenderData = [];
    this.totalMale = 0;
    this.totalFemale = 0;
    this.option_overall_gender.series[0].data = [];
}
// === 4. Quota-wise Admissions ===
if (res.data.admission_quota_ratio) {
    const quotaRaw = res.data.admission_quota_ratio;

    this.quotaNames = quotaRaw.map(item => item.quota);

    // Clear series
    this.option_quota_admissions.series = [];
    this.option_quota_admissions.legend.data = [];

    const colors = ['#5470C6', '#EE6666', '#91CC75', '#FAC858'];  // Blue, Red, Green, Yellow

    // Use divisions from first quota item (all should have same)
    const divisions = quotaRaw[0].divisions || [];

    divisions.forEach((division, idx) => {
        const seriesData = quotaRaw.map(item => item.counts[idx] || 0);

        this.option_quota_admissions.legend.data.push(division);
        this.option_quota_admissions.series.push({
            name: division,
            type: 'bar',
            barWidth: 25,
            itemStyle: { color: colors[idx % colors.length] },
            label: {
                show: true,
                position: 'top',
                fontSize: 14,
                fontWeight: 'bold'
            },
            data: seriesData
        });
    });

    this.option_quota_admissions.xAxis.data = this.quotaNames;

    // Stats
    this.totalQuotas = quotaRaw.length;

    let maxTotal = 0;
    let maxQuota = "N/A";
    quotaRaw.forEach(item => {
        const total = item.counts.reduce((a, b) => a + b, 0);
        if (total > maxTotal) {
            maxTotal = total;
            maxQuota = `${item.quota} (${maxTotal} students)`;
        }
    });
    this.highestQuota = maxQuota;

} else {
    this.quotaNames = [];
    this.option_quota_admissions.xAxis.data = [];
    this.option_quota_admissions.series = [];
    this.option_quota_admissions.legend.data = [];
    this.totalQuotas = 0;
    this.highestQuota = "N/A";
}
// === 5. Religion-wise Admissions ===
if (res.data.admission_religion_ratio) {
    const religionRaw = res.data.admission_religion_ratio;

    this.religionNames = religionRaw.map(item => item.religion);

    this.option_religion_admissions.series = [];
    this.option_religion_admissions.legend.data = [];

    const colors = ['#5470C6', '#EE6666', '#91CC75', '#FAC858'];

    const divisions = religionRaw[0].divisions || [];

    divisions.forEach((division, idx) => {
        const seriesData = religionRaw.map(item => item.counts[idx] || 0);

        this.option_religion_admissions.legend.data.push(division);
        this.option_religion_admissions.series.push({
            name: division,
            type: 'bar',
            barWidth: 25,
            itemStyle: { color: colors[idx % colors.length] },
            label: {
                show: true,
                position: 'top',
                fontSize: 14,
                fontWeight: 'bold'
            },
            data: seriesData
        });
    });

    this.option_religion_admissions.xAxis.data = this.religionNames;

    this.totalReligions = religionRaw.length;

    let maxTotal = 0;
    let maxReligion = "N/A";
    religionRaw.forEach(item => {
        const total = item.counts.reduce((a, b) => a + b, 0);
        if (total > maxTotal) {
            maxTotal = total;
            maxReligion = `${item.religion} (${maxTotal} students)`;
        }
    });
    this.dominantReligion = maxReligion;

} else {
    this.religionNames = [];
    this.option_religion_admissions.xAxis.data = [];
    this.option_religion_admissions.series = [];
    this.option_religion_admissions.legend.data = [];
    this.totalReligions = 0;
    this.dominantReligion = "N/A";
}
// === 6. Income-Groupwise Admissions ===
if (res.data.admission_income_ratio) {
    const incomeRaw = res.data.admission_income_ratio;

    this.incomeGroups = incomeRaw.map(item => item.group);

    this.option_income_admissions.series = [];
    this.option_income_admissions.legend.data = [];

    const colors = ['#5470C6', '#EE6666', '#91CC75', '#FAC858'];

    const divisions = incomeRaw[0].divisions || [];

    divisions.forEach((division, idx) => {
        const seriesData = incomeRaw.map(item => item.counts[idx] || 0);

        this.option_income_admissions.legend.data.push(division);
        this.option_income_admissions.series.push({
            name: division,
            type: 'bar',
            barWidth: 30,
            itemStyle: { color: colors[idx % colors.length] },
            label: {
                show: true,
                position: 'top',
                fontSize: 16,
                fontWeight: 'bold'
            },
            data: seriesData
        });
    });

    this.option_income_admissions.xAxis.data = this.incomeGroups;

    this.totalIncomeGroups = incomeRaw.length;

    let maxTotal = 0;
    let maxGroup = "N/A";
    incomeRaw.forEach(item => {
        const total = item.counts.reduce((a, b) => a + b, 0);
        if (total > maxTotal) {
            maxTotal = total;
            maxGroup = `${item.group} (${maxTotal} students)`;
        }
    });
    this.dominantIncomeGroup = maxGroup;

} else {
    this.incomeGroups = [];
    this.option_income_admissions.xAxis.data = [];
    this.option_income_admissions.series = [];
    this.option_income_admissions.legend.data = [];
    this.totalIncomeGroups = 0;
    this.dominantIncomeGroup = "N/A";
}
// === 7. Category-wise Admissions (Categories on X-axis) ===
if (res.data.admission_category_ratio) {
    const categoryRaw = res.data.admission_category_ratio;

    // X-axis: Categories
    this.categoryNames = categoryRaw.map(item => item.category);

    // Clear series
    this.option_category_admissions.series = [];
    this.option_category_admissions.legend.data = [];

    const colors = ['#5470C6', '#EE6666', '#91CC75', '#FAC858'];  // Blue, Red, Green, Yellow

    // Use divisions (classes) from first item
    const divisions = categoryRaw[0].divisions || [];

    // One series per class
    divisions.forEach((division, idx) => {
        const seriesData = categoryRaw.map(item => item.counts[idx] || 0);

        this.option_category_admissions.legend.data.push(division);
        this.option_category_admissions.series.push({
            name: division,
            type: 'bar',
            barWidth: 25,
            barGap: '20%',
            itemStyle: { color: colors[idx % colors.length] },
            label: {
                show: true,
                position: 'top',
                fontSize: 14,
                fontWeight: 'bold'
            },
            data: seriesData
        });
    });

    this.option_category_admissions.xAxis.data = this.categoryNames;

    this.totalCategories = categoryRaw.length;

    let maxTotal = 0;
    let maxCategory = "N/A";
    categoryRaw.forEach(item => {
        const total = item.counts.reduce((a, b) => a + b, 0);
        if (total > maxTotal) {
            maxTotal = total;
            maxCategory = `${item.category} (${maxTotal} students)`;
        }
    });
    this.dominantCategory = maxCategory;

} else {
    this.categoryNames = [];
    this.option_category_admissions.xAxis.data = [];
    this.option_category_admissions.series = [];
    this.option_category_admissions.legend.data = [];
    this.totalCategories = 0;
    this.dominantCategory = "N/A";
}
    } catch (err) {
        console.error("Admission data fetch error:", err);
        this.showSnackbar("#b71c1c", "Failed to load admission data");

        // Reset on error
        this.admissionClasses = [];
        this.admissionCounts = [];
        this.genderClasses = [];
        this.maleAdmissions = [];
        this.femaleAdmissions = [];
        this.totalAdmissions = 0;
        this.highestAdmissionClass = "N/A";
        this.mostMaleClass = "N/A";
        this.mostFemaleClass = "N/A";
    }
},
async fetchAcademicsData() {
    if (!this.selectedAY || !this.selectedStandard) return;

    const data = {
        selected_ay: this.selectedAY,
        selected_standard: this.selectedStandard
    };

    try {
        const res = await axios.post("/Analytics/getAcademicsCountAnalytics", data);
        if (res.data.flag === "YES") {
            if (res.data.syllabus_completion_data) {
                const raw = res.data.syllabus_completion_data;
                this.syllabusClasses = raw.map(item => item.division || "Unknown");
                this.syllabusPercentages = raw.map(item => item.completion_percentage || 0);

                this.option_syllabus_completion.xAxis.data = this.syllabusClasses;
                this.option_syllabus_completion.series[0].data = this.syllabusPercentages;
// === 1. Syllabus Completion % ===
                if (this.syllabusPercentages.length > 0) {
                    const maxVal = Math.max(...this.syllabusPercentages);
                    const minVal = Math.min(...this.syllabusPercentages);
                    const maxIdx = this.syllabusPercentages.indexOf(maxVal);
                    const minIdx = this.syllabusPercentages.indexOf(minVal);
                    this.highestSyllabusClass = `${this.syllabusClasses[maxIdx]} (${maxVal}%)`;
                    this.lowestSyllabusClass = `${this.syllabusClasses[minIdx]} (${minVal}%)`;
                }
            } else {
                this.syllabusClasses = [];
                this.syllabusPercentages = [];
                this.option_syllabus_completion.xAxis.data = [];
                this.option_syllabus_completion.series[0].data = [];
                this.highestSyllabusClass = "N/A";
                this.lowestSyllabusClass = "N/A";
            }
        } else {
            this.showSnackbar("#b71c1c", res.data.msg || "No data found");
            this.syllabusClasses = [];
            this.syllabusPercentages = [];
            this.option_syllabus_completion.xAxis.data = [];
            this.option_syllabus_completion.series[0].data = [];
            this.highestSyllabusClass = "N/A";
            this.lowestSyllabusClass = "N/A";
        }
        // === 2. Planned Vs Actual Progress  ===
        if (res.data.progress_over_weeks) {
                const prog = res.data.progress_over_weeks;
                this.progressWeeks = prog.weeks || [];
                this.plannedProgress = prog.planned || [];
                this.actualProgress = prog.actual || [];

                this.option_progress_chart.xAxis.data = this.progressWeeks;
                this.option_progress_chart.series[0].data = this.plannedProgress;
                this.option_progress_chart.series[1].data = this.actualProgress;
            } else {
                this.progressWeeks = [];
                this.plannedProgress = [];
                this.actualProgress = [];
                this.option_progress_chart.xAxis.data = [];
                this.option_progress_chart.series[0].data = [];
                this.option_progress_chart.series[1].data = [];
            }
            // === 3. Time Taken Per Chapter ===
            if (res.data.chapter_time_data) {
                const chap = res.data.chapter_time_data;
                this.chapterNames = chap.map(item => item.chapter || "Unknown");
                this.chapterHours = chap.map(item => item.hours || 0);

                this.option_chapter_time.xAxis.data = this.chapterNames;
                this.option_chapter_time.series[0].data = this.chapterHours;

                if (this.chapterHours.length > 0) {
                    const maxVal = Math.max(...this.chapterHours);
                    const minVal = Math.min(...this.chapterHours.filter(h => h > 0)); // avoid 0 if all zero
                    const maxIdx = this.chapterHours.indexOf(maxVal);
                    const minIdx = this.chapterHours.indexOf(minVal);

                    this.longestChapter = `${this.chapterNames[maxIdx]} (${maxVal} hrs)`;
                    this.shortestChapter = minVal > 0 ? `${this.chapterNames[minIdx]} (${minVal} hrs)` : "N/A";
                }
            } else {
                this.chapterNames = [];
                this.chapterHours = [];
                this.option_chapter_time.xAxis.data = [];
                this.option_chapter_time.series[0].data = [];
                this.longestChapter = "N/A";
                this.shortestChapter = "N/A";
            }
                        // === 4. Classwise Syllabus Completion % ===
            if (res.data.syllabus_completion_data) {
                const raw = res.data.syllabus_completion_data;

                this.classwiseClasses = raw.map(item => `${item.standard}-${item.division}`);
                this.classwisePercentages = raw.map(item => item.completion_percentage || 0);

                this.option_classwise_completion.xAxis.data = this.classwiseClasses;
                this.option_classwise_completion.series[0].data = this.classwisePercentages;

                if (this.classwisePercentages.length > 0) {
                    const maxVal = Math.max(...this.classwisePercentages);
                    const minVal = Math.min(...this.classwisePercentages);
                    const maxIdx = this.classwisePercentages.indexOf(maxVal);
                    const minIdx = this.classwisePercentages.indexOf(minVal);

                    this.highestClasswise = `${this.classwiseClasses[maxIdx]} (${maxVal}%)`;
                    this.lowestClasswise = `${this.classwiseClasses[minIdx]} (${minVal}%)`;
                }
            } else {
                this.classwiseClasses = [];
                this.classwisePercentages = [];
                this.option_classwise_completion.xAxis.data = [];
                this.option_classwise_completion.series[0].data = [];
                this.highestClasswise = "N/A";
                this.lowestClasswise = "N/A";
            }
                        // === 5. Topics Planned Vs Covered ===
            if (res.data.topics_planned_vs_covered) {
                const topicsData = res.data.topics_planned_vs_covered;

                this.topicsClasses = topicsData.map(item => item.class_label);
                this.plannedTopics = topicsData.map(item => item.planned_topics);
                this.coveredTopics = topicsData.map(item => item.covered_topics);

                this.option_topics_planned_covered.xAxis.data = this.topicsClasses;
                this.option_topics_planned_covered.series[0].data = this.plannedTopics;
                this.option_topics_planned_covered.series[1].data = this.coveredTopics;

                if (this.coveredTopics.length > 0) {
                    const maxCovered = Math.max(...this.coveredTopics);
                    const minCovered = Math.min(...this.coveredTopics);
                    const maxIdx = this.coveredTopics.indexOf(maxCovered);
                    const minIdx = this.coveredTopics.indexOf(minCovered);

                    this.bestCoverageClass = `${this.topicsClasses[maxIdx]} (${maxCovered} covered)`;
                    this.mostBehindClass = `${this.topicsClasses[minIdx]} (${minCovered} covered)`;
                }
            } else {
                this.topicsClasses = [];
                this.plannedTopics = [];
                this.coveredTopics = [];
                this.option_topics_planned_covered.xAxis.data = [];
                this.option_topics_planned_covered.series[0].data = [];
                this.option_topics_planned_covered.series[1].data = [];
                this.bestCoverageClass = "N/A";
                this.mostBehindClass = "N/A";
            }
                        // === 6. Classwise Attendance % ===
            if (res.data.classwise_attendance_data) {
                const att = res.data.classwise_attendance_data;

                this.attendanceClasses = att.map(item => item.class_label);
                this.attendancePercentages = att.map(item => item.attendance_percentage || 0);

                this.option_classwise_attendance.xAxis.data = this.attendanceClasses;
                this.option_classwise_attendance.series[0].data = this.attendancePercentages;

                if (this.attendancePercentages.length > 0) {
                    const maxVal = Math.max(...this.attendancePercentages);
                    const minVal = Math.min(...this.attendancePercentages);
                    const maxIdx = this.attendancePercentages.indexOf(maxVal);
                    const minIdx = this.attendancePercentages.indexOf(minVal);

                    this.bestAttendanceClass = `${this.attendanceClasses[maxIdx]} (${maxVal}%)`;
                    this.lowestAttendanceClass = `${this.attendanceClasses[minIdx]} (${minVal}%)`;
                }
            } else {
                this.attendanceClasses = [];
                this.attendancePercentages = [];
                this.option_classwise_attendance.xAxis.data = [];
                this.option_classwise_attendance.series[0].data = [];
                this.bestAttendanceClass = "N/A";
                this.lowestAttendanceClass = "N/A";
            }
    } catch (err) {
        console.error("Academics data fetch error:", err);
        this.showSnackbar("#b71c1c", "Failed to load academics data");
        this.syllabusClasses = [];
        this.syllabusPercentages = [];
        this.option_syllabus_completion.xAxis.data = [];
        this.option_syllabus_completion.series[0].data = [];
    }
},
        getInstCourse(std) {
            this.course_list = [],
                this.course = null
            this.course_list = std.coff_list
            if (this.course_list == '') {
                this.showSnackbar("#b71c1c", "No Course Found For Selected Standard...");
                return
            }

        },
        getInst(course) {
            this.inst_list = [],
                this.inst = null
            this.inst_list = ["All"];
            this.inst = "All";
            this.inst_list = course.inst_list
            this.inst_list.unshift("All");
            this.inst = this.inst_list[0];
            if (this.inst_list == '') {
                this.showSnackbar("#b71c1c", "No Instructor Found For Selected Course...");
                return
            }

        },

        async fetchCourseResultData() {
            this.loader = true
            const data = {
                // inst: this.inst,
                course: this.course.coff_id,
                semester: this.semester
            }
            try {
                const res = await axios.post("/Analytics/getInstCourseResultAnalytics", data);
                if (res.data.flag == "YES") {
                    this.CourseDetails = true;
                    this.result_bar_graph_details = res.data.result_bar_graph_details
                    this.option_result.xAxis.data = this.result_bar_graph_details[1];
                    this.option_result.series[0].data = this.result_bar_graph_details[0];

                    this.resultBarGraphSum = this.result_bar_graph_details[0].reduce((sum, value) => sum + value, 0);

                    this.avg_ass_type_result_bar_graph_details = res.data.avg_ass_type_result_bar_graph_details
                    this.option_avg_result.xAxis.data = this.avg_ass_type_result_bar_graph_details[1];
                    this.option_avg_result.series[0].data = this.avg_ass_type_result_bar_graph_details[0];

                    this.marks_bar_graph_details = res.data.marks_bar_graph_details
                    this.option_marks_result.xAxis.data = this.marks_bar_graph_details[0];
                    this.option_marks_result.series[0].data = this.marks_bar_graph_details[1];
                    this.loader = false
                    if (res.data.class_wise_avg_marks) {
                        const classData = res.data.class_wise_avg_marks;

                        this.option_class_avg.xAxis.data = classData.classes;
                        this.option_class_avg.series[0].data = classData.averages;

                        // Optional: Show highest & lowest class
                        const maxIdx = classData.averages.indexOf(Math.max(...classData.averages));
                        const minIdx = classData.averages.indexOf(Math.min(...classData.averages));

                        this.highestClass = `${classData.classes[maxIdx]} (${classData.averages[maxIdx]} marks)`;
                        this.lowestClass = `${classData.classes[minIdx]} (${classData.averages[minIdx]} marks)`;
                    } else {
                        this.option_class_avg.xAxis.data = [];
                        this.option_class_avg.series[0].data = [];
                        this.highestClass = "N/A";
                        this.lowestClass = "N/A";
                    }

                    if (res.data.grade_wise_avg_marks) {
                        const gradeData = res.data.grade_wise_avg_marks;

                        this.option_grade_avg.xAxis.data = gradeData.grades;
                        this.option_grade_avg.series[0].data = gradeData.averages;

                        // Find highest & lowest
                        const maxVal = Math.max(...gradeData.averages);
                        const minVal = Math.min(...gradeData.averages);
                        const maxIdx = gradeData.averages.indexOf(maxVal);
                        const minIdx = gradeData.averages.indexOf(minVal);

                        this.highestGrade = `${gradeData.grades[maxIdx]} (${maxVal} marks)`;
                        this.lowestGrade = `${gradeData.grades[minIdx]} (${minVal} marks)`;
                    } else {
                        this.option_grade_avg.xAxis.data = [];
                        this.option_grade_avg.series[0].data = [];
                        this.highestGrade = "N/A";
                        this.lowestGrade = "N/A";
                    }

                    if (res.data.class_wise_pass_percentage) {
                        const passData = res.data.class_wise_pass_percentage;
                        this.option_class_pass.xAxis.data = passData.classes;
                        this.option_class_pass.series[0].data = passData.percentages;

                        // Highest & Lowest
                        if (passData.percentages.length > 0) {
                            const maxVal = Math.max(...passData.percentages);
                            const minVal = Math.min(...passData.percentages);
                            const maxIdx = passData.percentages.indexOf(maxVal);
                            const minIdx = passData.percentages.indexOf(minVal);

                            this.highestPassClass = `${passData.classes[maxIdx]} (${maxVal}%)`;
                            this.lowestPassClass = `${passData.classes[minIdx]} (${minVal}%)`;
                        }
                    } else {
                        this.option_class_pass.xAxis.data = [];
                        this.option_class_pass.series[0].data = [];
                        this.highestPassClass = "N/A";
                        this.lowestPassClass = "N/A";
                    }
                    // Grade-wise % Passing
if (res.data.grade_wise_pass_percentage) {
    const gpassData = res.data.grade_wise_pass_percentage;
    this.option_grade_pass.xAxis.data = gpassData.grades;
    this.option_grade_pass.series[0].data = gpassData.percentages;

    if (gpassData.percentages.length > 0) {
        const maxVal = Math.max(...gpassData.percentages);
        const minVal = Math.min(...gpassData.percentages);
        const maxIdx = gpassData.percentages.indexOf(maxVal);
        const minIdx = gpassData.percentages.indexOf(minVal);

        this.highestGradePass = `${gpassData.grades[maxIdx]} (${maxVal}%)`;
        this.lowestGradePass  = `${gpassData.grades[minIdx]} (${minVal}%)`;
    }
} else {
    this.option_grade_pass.xAxis.data = [];
    this.option_grade_pass.series[0].data = [];
    this.highestGradePass = "N/A";
    this.lowestGradePass = "N/A";
}
// Subjectwise Avg Marks
if (res.data.subject_wise_avg_marks) {
    const subjData = res.data.subject_wise_avg_marks;
    this.option_subject_avg.xAxis.data = subjData.divisions;
    this.option_subject_avg.series[0].data = subjData.averages;

    if (subjData.averages.length > 0) {
        const maxVal = Math.max(...subjData.averages);
        const minVal = Math.min(...subjData.averages);
        const maxIdx = subjData.averages.indexOf(maxVal);
        const minIdx = subjData.averages.indexOf(minVal);

        this.highestSubjectClass = `${subjData.divisions[maxIdx]} (${maxVal} marks)`;
        this.lowestSubjectClass  = `${subjData.divisions[minIdx]} (${minVal} marks)`;
    }
} else {
    this.option_subject_avg.xAxis.data = [];
    this.option_subject_avg.series[0].data = [];
    this.highestSubjectClass = "N/A";
    this.lowestSubjectClass = "N/A";
}
// Class Test - Grade-wise Performance
if (res.data.class_test_grade_performance) {
    const ctData = res.data.class_test_grade_performance;
    this.option_class_test_performance.xAxis.data = ctData.classes;
    this.option_class_test_performance.series[0].data = ctData.averages;

    if (ctData.averages.length > 0) {
        const maxVal = Math.max(...ctData.averages);
        const minVal = Math.min(...ctData.averages);
        const maxIdx = ctData.averages.indexOf(maxVal);
        const minIdx = ctData.averages.indexOf(minVal);

        this.highestClassTest = `${ctData.classes[maxIdx]} (${maxVal} marks)`;
        this.lowestClassTest  = `${ctData.classes[minIdx]} (${minVal} marks)`;
    }
} else {
    this.option_class_test_performance.xAxis.data = [];
    this.option_class_test_performance.series[0].data = [];
    this.highestClassTest = "N/A";
    this.lowestClassTest = "N/A";
}

if (res.data.grade_distribution_pie) {
    const gd = res.data.grade_distribution_pie;

    // Dynamic title
    this.option_grade_distribution.title.text = gd.title;

    // Pie data
    this.option_grade_distribution.series[0].data = gd.pieData;

    // Info boxes
    this.mostCommonGrade = gd.mostCommonGrade;
    this.totalStudentsInDist = gd.totalStudents;

} else {
    this.option_grade_distribution.title.text = "Grade Distribution";
    this.option_grade_distribution.series[0].data = [];
    this.mostCommonGrade = "N/A";
    this.totalStudentsInDist = 0;
}
// Result Analysis - Cycle Comparison
if (res.data.cycle_comparison_result_analysis) {
    const cc = res.data.cycle_comparison_result_analysis;

    this.option_cycle_comparison.xAxis.data = cc.grades;

    // Clear and rebuild series
    this.option_cycle_comparison.series = [];
    this.option_cycle_comparison.legend.data = [];

    const colors = ['#5470C6', '#EE6666', '#91CC75'];  // Blue, Orange, Gray

    cc.cycles.forEach((cycleName, index) => {
        const shortName = cycleName.replace(/Cycle Test|\s+/g, '').trim();
        const displayName = 'CY-' + shortName;

        this.option_cycle_comparison.legend.data.push(displayName);

        this.option_cycle_comparison.series.push({
            name: displayName,
            type: 'bar',
            barWidth: 30,
            itemStyle: { color: colors[index % colors.length] },
            label: {
                show: true,
                position: 'top',
                fontSize: 16,
                fontWeight: 'bold',
                formatter: '{c}'
            },
            data: cc.seriesData[index] || []
        });
    });

    // Best cycle
    if (cc.seriesData.length > 0) {
        const totals = cc.seriesData.map(arr => arr.reduce((a,b) => a + b, 0));
        const maxTotal = Math.max(...totals);
        const bestIdx = totals.indexOf(maxTotal);
        this.bestCycle = `${this.option_cycle_comparison.legend.data[bestIdx]} (${maxTotal} total marks)`;
        this.totalCycles = cc.cycles.length;
    }

} else {
    this.option_cycle_comparison.xAxis.data = [];
    this.option_cycle_comparison.series = [];
    this.option_cycle_comparison.legend.data = [];
    this.bestCycle = "N/A";
    this.totalCycles = 0;
}
// Genderwise Performance
if (res.data.genderwise_performance) {
    const gp = res.data.genderwise_performance;

    this.option_gender_performance.xAxis.data = gp.grades;
    this.option_gender_performance.series[0].data = gp.maleAverages;    // Male
    this.option_gender_performance.series[1].data = gp.femaleAverages;  // Female

    // Overall best gender
    const maleTotal = gp.maleAverages.reduce((a, b) => a + b, 0);
    const femaleTotal = gp.femaleAverages.reduce((a, b) => a + b, 0);
    if (maleTotal > femaleTotal) {
        this.overallBestGender = `Male (${maleTotal} total marks)`;
    } else if (femaleTotal > maleTotal) {
        this.overallBestGender = `Female (${femaleTotal} total marks)`;
    } else {
        this.overallBestGender = "Equal Performance";
    }

    // Biggest gap
    let maxGap = 0;
    let gapGrade = "N/A";
    gp.grades.forEach((grade, i) => {
        const diff = Math.abs(gp.maleAverages[i] - gp.femaleAverages[i]);
        if (diff > maxGap) {
            maxGap = diff;
            gapGrade = `${grade} (${diff} marks difference)`;
        }
    });
    this.biggestGapGrade = gapGrade;

} else {
    this.option_gender_performance.xAxis.data = [];
    this.option_gender_performance.series[0].data = [];
    this.option_gender_performance.series[1].data = [];
    this.overallBestGender = "N/A";
    this.biggestGapGrade = "N/A";
}
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong...");  // show snackbar
                this.loader = false
            }
            finally {
                this.loader = false
            }
        },
        async fetchCourseRegistrationData() {
            this.loader = true
            this.showInfo = true;
            const data = {
                course: this.course.coff_inst_id
            }
            try {
                const res = await axios.post("/Analytics/getInstCourseRegistrationAnalytics", data);
                if (res.data.flag == "YES") {
                    this.bar_graph_details = res.data.bar_graph_details
                    this.option.xAxis.data = this.bar_graph_details[1];
                    this.option.series[0].data = this.bar_graph_details[0];
                    this.loader = false
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong...");  // show snackbar
                this.loader = false
            }
            finally {
                this.loader = false;
            }
        },
        // applyFilter() {
        //     if (!this.ay || !this.leaveType) {
        //         this.showSnackbar("#b71c1c", "Please select both AY and Leave Type");
        //         return;
        //     }
        //     this.apply = true;
        //     this.LeaveData.title.text = `Leave Type :: ${this.leaveType} :: ${this.ay}`;
        //     const filteredData = this.employee_leave_transaction_details_list.filter(transaction => transaction.leavetype == this.leaveType && transaction.leaveacademicyear == this.ay)
        //     // console.log("filteredData", this.leaveType + this.ay);
        //     this.totalValue = filteredData.map(transaction => transaction.totalleaves).reduce((acc, curr) => acc + curr, 0);
        //     this.inProgressValue = filteredData.map(transaction => transaction.leavesinprogress).reduce((acc, curr) => acc + curr, 0);
        //     this.availedValue = filteredData.map(transaction => transaction.availedleaves).reduce((acc, curr) => acc + curr, 0);
        //     this.balanceValue = filteredData.map(transaction => transaction.balanceleaves).reduce((acc, curr) => acc + curr, 0);
        //     // console.log(" total" + total + " process " + inProgress + " availed" + availed + "balance " + balance);

        //     // const totalPercent = total > 0 ? ((total / total) * 100).toFixed(2) : 0;
        //     // const inProgressPercent = inProgress > 0 ? ((inProgress / total) * 100).toFixed(2) : 0;
        //     // const availedPercent = availed > 0 ? ((availed / total) * 100).toFixed(2) : 0;
        //     // const balancePercent = balance > 0 ? ((balance / total) * 100).toFixed(2) : 0;
        //     // console.log(" total " + totalPercent + " process " + inProgressPercent + " availed " + availedPercent + " balance " + balancePercent);

        //     const pieData = [
        //         { value: this.totalValue, name: `Total` },
        //         { value: this.inProgressValue, name: `In-Process` },
        //         { value: this.availedValue, name: `Availed` },
        //         { value: this.balanceValue, name: `Balance` },
        //     ];

        //     this.LeaveData.series[0].data = pieData;
        // },
        // async getInstLeaveData() {
        //     this.loader = true;
        //     const data = {
        //         inst: this.inst
        //     };

        //     try {
        //         const res = await axios.post("/Analytics/instructorLeaveAnalyticsHome", data);

        //         if (res.data.flag === "YES") {
        //             // this.showSnackbar("#4CAF50", "Data fetched successfully");
        //             this.leave_type_list = res.data.leave_type_list;
        //             this.ay_list = res.data.ay_list;
        //             this.employee_leave_transaction_details_list = res.data.employee_leave_transaction_details_list;
        //             // console.log("trans list " + JSON.stringify(this.employee_leave_transaction_details_list, null, 2));
        //         } else {
        //             this.showSnackbar("#b71c1c", "No data found");
        //         }
        //     } catch (error) {
        //         this.showSnackbar("#b71c1c", "Something went wrong...");
        //     } finally {
        //         this.loader = false;
        //     }
        // },
        async fetchMyLeaveAnalytics() {
    if (!this.selectedAy) return

    this.loadingLeave = true
    this.leaveDataLoaded = false

    try {
      const payload = {
        academicYearId: Number(this.selectedAy),
      }

      const res = await axios.post('/Analytics/instructorLeaveAnalyticsSelf', payload)

      if (res.data.flag === 'YES') {
        this.myLeaveAnalytics = res.data.leave_balance || []

        // Find AY name for display
        const ayItem = this.ayList.find(a => a.id === this.selectedAy)
        this.selectedAyName = ayItem ? ayItem.ay : 'Selected Year'

        this.leaveDataLoaded = true
      } else {
        this.myLeaveAnalytics = []
        this.showMessage('warning', res.data.msg || 'No leave data found')
      }
    } catch (err) {
      console.error(err)
      this.showMessage('error', 'Failed to load leave analytics')
    } finally {
      this.loadingLeave = false
    }
  },

  getPieChartOptions(lt) {
  const colorMap = {
    'Total':      '#40b8e6',    // blue
    'In-Process': '#ffeb3b',    // yellow
    'Availed':    '#f54a94',    // pink
    'Balance':    '#73d0a0'     // green
  };

  const data = [
    {
      value: lt.total || 0,
      name: `Total\n${lt.total || 0} days`,
      itemStyle: { color: colorMap['Total'] }
    },
    {
      value: lt.inProgress || 0,
      name: `In-Process\n${lt.inProgress || 0} days`,
      itemStyle: { color: colorMap['In-Process'] }
    },
    {
      value: lt.availed || 0,
      name: `Availed\n${lt.availed || 0} days`,
      itemStyle: { color: colorMap['Availed'] }
    },
    {
      value: lt.balance || 0,
      name: `Balance\n${lt.balance || 0} days`,
      itemStyle: { color: colorMap['Balance'] }
    }
  ].filter(item => item.value > 0);

  return {
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c} days ({d}%)'
    },
    series: [
      {
        name: lt.leaveType,
        type: 'pie',
        radius: '60%',                    // Full circle (no hole)
        center: ['50%', '55%'],           // Slightly lower to balance label space
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 6,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: true,
          position: 'outside',
          formatter: '{b}',               // Uses the \n in name for two lines
          fontSize: 14,
          fontWeight: 'bold',
          color: '#333',
          padding: [0, 8],
          alignTo: 'labelLine'
        },
        labelLine: {
          show: true,
          length: 24,
          length2: 14,
          minTurnAngle: 90,
          smooth: 0.2
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 12,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.18)'
          }
        },
        data: data
      }
    ]
  };
},
        async getInstQuizData() {
            this.loading4 = true;
            this.overall = true;
            this.filtered = false;
            const data = {
                inst: this.inst
            };
            try {
                const res = await axios.post("/Analytics/instructorQuizAnalyticsHome", data);

                if (res.data.flag === "YES") {
                    // this.showSnackbar("#4CAF50", "Data fetched successfully");
                    this.ay_list = res.data.ay_list;
                    this.quiz_data = res.data.data;
                    if (this.quiz_data != '') {
                        const totalMarks = res.data.data.map((markData) => markData.average_total_marks);
                        const obtainedMarks = res.data.data.map((markData) => markData.average_marks_obtained);

                        this.quiz_overall.xAxis.data = this.quiz_data.map((markData) => markData.course);
                        this.quiz_overall.series[0].data = totalMarks;
                        this.quiz_overall.series[1].data = obtainedMarks;
                    }
                    else {
                        this.showSnackbar("#b71c1c", "No data found");
                    }

                } else {
                    this.showSnackbar("#b71c1c", "No data found");
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong...");
            } finally {
                this.loading4 = false;
            }
        },
        async getInstQuizByAy() {
            this.loader = true;
            this.overall = false;
            this.showGraph = true;
            const data = {
                inst: this.inst,
                course: this.course.coff_id,
                // semester: this.semester
            };
            if (this.std == null || this.course == null || this.inst == null) {
                this.showSnackbar("#b71c1c", "Please fill all the fields");
                this.loader = false;
                this.showGraph = false;
                return;
            }
            try {
                const res = await axios.post("/Analytics/instructorQuizAnalyticsByAy", data);

                if (res.data.flag === "YES") {
                    // this.showSnackbar("#4CAF50", "Data fetched successfully");
                    this.ay_list = res.data.ay_list;
                    this.quiz_data = res.data.data;
                    if (this.quiz_data != '') {
                        const totalMarks = res.data.data.map((markData) => markData.average_total_marks);
                        const obtainedMarks = res.data.data.map((markData) => markData.average_marks_obtained);

                        this.quiz_byAy.xAxis.data = this.ay_list.map(item => item.ay);
                        this.quiz_byAy.series[0].data = totalMarks;
                        this.quiz_byAy.series[1].data = obtainedMarks;
                    }
                    else {
                        this.showSnackbar("#b71c1c", "No data found");
                        this.showGraph = false;
                    }

                } else {
                    this.showSnackbar("#b71c1c", "No data found");
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong...");
            } finally {
                this.loader = false;
            }
        },
        async getInstHomeworkData() {
            this.loading4 = true;
            this.overall = true;
            this.showGraph = false;
            this.filtered = false;
            const data = {
                inst: this.inst
            };

            try {
                const res = await axios.post("/Analytics/instructorHomeworkAnalyticsHome", data);

                if (res.data.flag === "YES") {
                    // this.showSnackbar("#4CAF50", "Data fetched successfully");
                    this.ay_list = res.data.ay_list;
                    this.homework_data = res.data.data;
                    const filteredHomeworkData = this.homework_data.filter((markData) =>
                        markData.course && markData.total_homework_count !== undefined && markData.average_submissions_per_homework !== undefined
                    );
                    if (this.homework_data != '') {
                        const totalMarks = filteredHomeworkData.map((markData) => markData.total_homework_count);
                        const obtainedMarks = filteredHomeworkData.map((markData) => markData.average_submissions_per_homework);

                        this.homework_overall.xAxis.data = filteredHomeworkData.map((markData) => markData.course);
                        this.homework_overall.series[0].data = obtainedMarks;
                        this.homework_overall.series[1].data = totalMarks;
                    }
                    else {
                        this.showSnackbar("#b71c1c", "No data found");
                        this.overall = false;
                    }
                } else {
                    this.showSnackbar("#b71c1c", "Something went wrong");
                    this.overall = false;
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong...");
                this.overall = false;
            } finally {
                this.loading4 = false;
            }
        },
      async getInstHomeworkByAy() {
    this.loader = true;
    this.overall = false;
    this.showGraph = true;

    // 1. Validation Check
    if (!this.std || !this.course || !this.inst) {
        this.showSnackbar("#b71c1c", "Please fill all the fields");
        this.loader = false;
        this.showGraph = false;
        return;
    }

    // 2. Extract specific IDs (Backend expects Integers or 'All')
    // Handle cases where inst might be an object or the string "All"
    const instructorId = (this.inst === 'All') 
        ? 'All' 
        : (this.inst.inst_id || this.inst.id);

    const divisionId = (this.inst === 'All') 
        ? 'All' 
        : (this.inst.div_off_id || 'All'); // Ensure this matches what backend expects

    const payload = {
        course: this.course.coff_id,
        standard: this.std.std_id || this.std.id,
        div: divisionId,
        inst: instructorId
    };

    try {
        const res = await axios.post("/Analytics/instructorHomeworkAnalyticsByAy", payload);

        if (res.data.flag === "YES") {
            const homeworkData = res.data.data || [];
            
            if (homeworkData.length > 0) {
                const courseTitle = this.course.coff_name;

                // Update Tooltip Config
                this.homework_byAy.tooltip = {
                    show: true,
                    trigger: "axis",
                    axisPointer: { type: "shadow" },
                    backgroundColor: "rgba(30,41,59,0.95)",
                    textStyle: { color: "#FFFFFF" },
                    formatter: `<b>${courseTitle}</b><br/>{a0}: <b>{c0}</b><br/>{a1}: <b>{c1}</b>`
                };

                // Update Title
                const empName = (this.inst === 'All') ? 'All Employees' : (this.inst.inst_name || 'Selected Employee');
                this.homework_byAy.title.text = `Assignments: Std ${this.std.std_name} | ${empName}`;

                // Map Chart Data
                this.homework_byAy.xAxis.data = res.data.ay_list ? res.data.ay_list.map(item => item.ay) : [];
                this.homework_byAy.series[0].data = homeworkData.map(d => d.average_submissions_per_homework);
                this.homework_byAy.series[1].data = homeworkData.map(d => d.total_homework_count);

            } else {
                this.showSnackbar("#ff9800", "No data found for this selection");
                this.showGraph = false;
            }
        } else {
            this.showSnackbar("#b71c1c", res.data.msg || "No data found");
            this.showGraph = false;
        }
    } catch (error) {
        this.showSnackbar("#b71c1c", "Error connecting to server");
        this.showGraph = false;
    } finally {
        this.loader = false;
    }
},
        async getInstAttendanceData() {
            this.overall = true;
            this.filtered = false;
            this.loading1 = true;
            const data = {
                inst: this.inst
            };

            try {
                const res = await axios.post("/Analytics/getInstructorAttendanceAnalytics", data);

                if (res.data.flag === "YES") {
                    console.log(res.data.data); // Log response to check structure

                    // Map directly to extract the values from each object in the array
                    const averageWorkingHours = res.data.data.map(instData => instData.averageWorkingHours || 0);
                    const averagePresentHours = res.data.data.map(instData => instData.averagePresentHours || 0);

                    // Set xAxis data from the 'ay' property
                    this.option1.xAxis.data = res.data.data.map(instData => instData.ay);

                    // Update series data for chart
                    this.option1.series[0].data = averageWorkingHours;
                    this.option1.series[1].data = averagePresentHours;

                    const totalWorkingHoursSum = averageWorkingHours.reduce((sum, hours) => sum + hours, 0);
                    const validEntriesCount = averageWorkingHours.filter(hours => hours > 0).length;

                    this.totalAverageWorkingHours = validEntriesCount > 0
                        ? (totalWorkingHoursSum / validEntriesCount).toFixed(2) : 0;

                } else {
                    this.showSnackbar("#b71c1c", "No data found");
                    this.loading1 = false;
                }
            } catch (error) {
                console.error("Error fetching data: ", error); // Log error details
                this.showSnackbar("#b71c1c", "Something went wrong...");
                this.loading1 = false;
            } finally {
                this.loading1 = false;
            }
        },
        async onLoad() {
            this.std_list = [],
                this.std = null,
                this.course_list = [],
                this.course = null,
                this.inst_list = [],
                this.inst = null
            try {
                const res = await axios.post("/Analytics/getInstCourseOffDetails");

                if (res.data.flag == "YES") {
                    this.std_list = res.data.standard_list
                    this.semester_list = res.data.semester_list
                    this.ay_list_other = res.data.ay_list
                    this.ay_list_is_inerp = res.data.ay_list_in_erp
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong...");  // show snackbar
            }
            finally {
                this.apply = false;
                this.ay = "";
                this.leaveType = "";
            }
        },
        async getInstructorAttendanceAnalyticsByAy() {
            if (this.ay_other == '' || this.ay_other == null) {
                this.showSnackbar("#b71c1c", "Please Select Academic Year...");
                return;
            }
            this.overall = false;
            this.filtered = true;
            this.getInstructorAttendanceAnalyticsByAy_fetch = true;
            this.loading2 = true;
            const data = {
                ay: this.ay_other
            };

            try {
                const res = await axios.post("/Analytics/getInstructorAttendanceAnalyticsByAy", data);

                if (res.data.flag === "YES") {
                    console.log(res.data.data); // Log response to check structure

                    // Map directly to extract the values from each object in the array
                    const averageWorkingHours = res.data.data.map(instData => instData.averageWorkingHours || 0);
                    const averagePresentHours = res.data.data.map(instData => instData.averagePresentHours || 0);

                    // Set xAxis data from the 'ay' property
                    this.option2.xAxis.data = res.data.data.map(instData => instData.ay);

                    // Update series data for chart
                    this.option2.series[0].data = averageWorkingHours;
                    this.option2.series[1].data = averagePresentHours;

                    const totalWorkingHoursSum = averageWorkingHours.reduce((sum, hours) => sum + hours, 0);
                    const validEntriesCount = averageWorkingHours.filter(hours => hours > 0).length;

                    this.totalAverageWorkingHours = validEntriesCount > 0
                        ? (totalWorkingHoursSum / validEntriesCount).toFixed(2) : 0;

                } else {
                    this.showSnackbar("#b71c1c", "No data found");
                    this.loading1 = false;
                }
            } catch (error) {
                console.error("Error fetching data: ", error); // Log error details
                this.showSnackbar("#b71c1c", "Something went wrong...");
                this.loading1 = false;
            } finally {
                this.loading1 = false;
            }
        },
        setActiveTab(tab) {
            this.activeTab = tab;
            this.resetFilters();
        },
        resetFilters() {
            this.profile_filtered_activities = false;
            this.profile_filtered_publications = false;
            this.profile_filtered_trainings = false;
            this.profile_overall = false;
            this.profile_overall_2 = false;
            this.profile_overall_3 = false;
            this.getInstructoPublicationAnalyticsByAy_fetch = false;
            this.getInstructoPublicationAnalyticsByAy_fetch_2 = false;
            this.getInstructoTrainingAnalyticsByAy_fetch_2 = false;
            this.getInstructoTrainingAnalyticsByAy_fetch = false;
            this.getInstructoTActivityAnalyticsByAy_fetch_2 = false;
            this.getInstructoTActivityAnalyticsByAy_fetch = false;
        },
        async getInstructoPublicationAnalytics() {
            this.profile_overall = true;
            this.loading3 = true;

            const data = {
                inst: this.inst
            };

            try {
                const res = await axios.post("/Analytics/getInstructoPublicationAnalytics", data);

                if (res.data.flag === "YES") {
                    console.log(res.data.data); // Log response to check structure

                    // Extract 'totalPublications' for the series data and 'ay' for the xAxis
                    const publications = res.data.data.map(instData => instData.totalPublications);
                    const years = res.data.data.map(instData => instData.ay);

                    // Update the chart's xAxis and series with the new data
                    this.publication_option.xAxis.data = years;  // xAxis will display the years
                    this.publication_option.series[0].data = publications;  // series data will display total publications

                    this.totalPublications = publications.reduce((sum, value) => sum + value, 0);

                } else {
                    this.showSnackbar("#b71c1c", "No data found");
                    this.loading3 = false;
                }
            } catch (error) {
                console.error("Error fetching data: ", error); // Log error details
                this.showSnackbar("#b71c1c", "Something went wrong...");
                this.loading3 = false;
            } finally {
                this.loading3 = false;
            }
        },
        async getInstructoPublicationAnalyticsByAy() {
            this.loader3 = true;

            let data;

            if (this.publicaton_radios === 'academic_year') {
                this.getInstructoPublicationAnalyticsByAy_fetch = true;
                this.getInstructoPublicationAnalyticsByAy_fetch_2 = false;
                if (this.ay_other === '' || this.ay_other === null) {
                    this.showSnackbar("#b71c1c", "Please Select Academic Year...");
                    this.getInstructoPublicationAnalyticsByAy_fetch = false;
                    this.loader3 = false;
                    return;
                }
                data = {
                    ay: this.ay_other
                };
            } else {
                this.getInstructoPublicationAnalyticsByAy_fetch = false;
                this.getInstructoPublicationAnalyticsByAy_fetch_2 = true;
                data = {
                    fromdate: this.fromdate,
                    todate: this.todate,
                    daterange: true, // Corrected to just `true`
                };
            }

            try {
                const res = await axios.post("/Analytics/getInstructoPublicationAnalyticsByAy", data);

                if (res.data.flag === "YES") {
                    console.log(res.data.data); // Log response to check structure

                    // Extract 'totalPublications' for the series data and 'ay' for the xAxis
                    const publications = res.data.data.map(instData => instData.totalPublications);
                    const years = res.data.data.map(instData => instData.ay);

                    // Update the chart's xAxis and series with the new data
                    this.publication_by_ay_option.xAxis.data = years;  // xAxis will display the years
                    this.publication_by_ay_option.series[0].data = publications;  // series data will display total publications

                    this.totalPublicationsByAy = publications.reduce((sum, value) => sum + value, 0);

                } else {
                    this.showSnackbar("#b71c1c", "No data found");
                    this.loader3 = false;
                }
            } catch (error) {
                console.error("Error fetching data: ", error); // Log error details
                this.showSnackbar("#b71c1c", "Something went wrong...");
            } finally {
                this.loader3 = false;
            }
        },
        async getInstructoTrainingAnalytics() {
            this.profile_overall_2 = true;
            this.loading3 = true;

            const data = {
                inst: this.inst
            };

            try {
                const res = await axios.post("/Analytics/getInstructoTrainingAnalytics", data);

                if (res.data.flag === "YES") {
                    console.log(res.data.data);
                    const training = res.data.data.map(instData => instData.totalTrainings);
                    const years = res.data.data.map(instData => instData.ay);
                    this.training_option.xAxis.data = years;
                    this.training_option.series[0].data = training;

                    this.totalTrainings = training.reduce((sum, val) => sum + val, 0);

                } else {
                    this.showSnackbar("#b71c1c", "No data found");
                    this.loading3 = false;
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
                this.showSnackbar("#b71c1c", "Something went wrong...");
                this.loading3 = false;
            } finally {
                this.loading3 = false;
            }
        },
        async getInstructoTrainingAnalyticsByAy() {
            // this.profile_overall = false;
            // this.profile_filtered = true;
            this.loader3 = true;

            let data;

            if (this.training_radios === 'academic_year') {
                this.getInstructoTrainingAnalyticsByAy_fetch_2 = false;
                this.getInstructoTrainingAnalyticsByAy_fetch = true;
                if (this.ay_is_inerp === '' || this.ay_is_inerp === null) {
                    this.showSnackbar("#b71c1c", "Please Select Academic Year...");
                    this.getInstructoTrainingAnalyticsByAy_fetch = false;
                    this.loader3 = false;
                    return;
                }
                data = {
                    ay: this.ay_is_inerp
                };
            } else {
                this.getInstructoTrainingAnalyticsByAy_fetch = false;
                this.getInstructoTrainingAnalyticsByAy_fetch_2 = true;
                data = {
                    fromdate: this.fromdate,
                    todate: this.todate,
                    daterange: true, // Corrected to just `true`
                };
            }

            try {
                const res = await axios.post("/Analytics/getInstructoTrainingAnalyticsByAy", data);

                if (res.data.flag === "YES") {
                    console.log(res.data.data);

                    const training = res.data.data.map(instData => instData.totalTrainings);
                    const years = res.data.data.map(instData => instData.ay);


                    this.training_by_ay_option.xAxis.data = years;
                    this.training_by_ay_option.series[0].data = training;

                    this.totalTrainingsByAy = training.reduce((sum, value) => sum + value, 0);

                } else {
                    this.showSnackbar("#b71c1c", "No data found");
                    this.loader3 = false;
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
                this.showSnackbar("#b71c1c", "Something went wrong...");
            } finally {
                this.loader3 = false;
            }
        },
        async getInstructoActivityAnalytics() {
            this.profile_overall_3 = true;
            this.loading3 = true;

            const data = {
                inst: this.inst
            };

            try {
                const res = await axios.post("/Analytics/getInstructoActivityAnalytics", data);

                if (res.data.flag === "YES") {
                    console.log(res.data.data);
                    const Activities = res.data.data.map(instData => instData.totalActivities);
                    const years = res.data.data.map(instData => instData.ay);
                    this.activities_option.xAxis.data = years;
                    this.activities_option.series[0].data = Activities;

                    this.totalActivities = Activities.reduce((sum, value) => sum + value, 0);

                } else {
                    this.showSnackbar("#b71c1c", "No data found");
                    this.loading3 = false;
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
                this.showSnackbar("#b71c1c", "Something went wrong...");
                this.loading3 = false;
            } finally {
                this.loading3 = false;
            }
        },
        async getInstructoTActivityAnalyticsByAy() {
            // this.profile_overall = false;
            // this.profile_filtered = true;
            this.loader3 = true;


            let data;

            if (this.activities_radios === 'academic_year') {
                this.getInstructoTActivityAnalyticsByAy_fetch_2 = false;
                this.getInstructoTActivityAnalyticsByAy_fetch = true;
                if (this.ay_activities === '' || this.ay_activities === null) {
                    this.showSnackbar("#b71c1c", "Please Select Academic Year...");
                    this.getInstructoTActivityAnalyticsByAy_fetch = false;
                    this.loader3 = false;
                    return;
                }
                data = {
                    ay: this.ay_activities
                };
            } else {
                this.getInstructoTActivityAnalyticsByAy_fetch_2 = true;
                this.getInstructoTActivityAnalyticsByAy_fetch = false;
                data = {
                    fromdate: this.fromdate,
                    todate: this.todate,
                    daterange: true, // Corrected to just `true`
                };
            }

            try {
                const res = await axios.post("/Analytics/getInstructoTActivityAnalyticsByAy", data);

                if (res.data.flag === "YES") {
                    console.log(res.data.data);
                    const Activities = res.data.data.map(instData => instData.totalActivities);
                    const years = res.data.data.map(instData => instData.ay);
                    this.activities_by_ay_option.xAxis.data = years;
                    this.activities_by_ay_option.series[0].data = Activities;

                    this.totalActivitiesByAy = Activities.reduce((sum, value) => sum + value, 0);

                } else {
                    this.showSnackbar("#b71c1c", "No data found");
                    this.loader3 = false;
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
                this.showSnackbar("#b71c1c", "Something went wrong...");
            } finally {
                this.loader3 = false;
            }
        },

    },
    mounted() {
        this.onLoad();
        // this.onLoad_for_ay();
        // this.getInstLeaveData();
        // this.getInstAttendanceData();
        this.selectSubTab("overall");
        this.getInstHomeworkData();
    },
};
</script>

<style scoped>
.squares {
    /* color: #f7989b; */
    height: 85px;
    width: 120px;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
}

.squares2 {
    /* color: #f7989b; */
    height: 125px;
    width: 170px;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
}

.grade-table {
    width: 72%;
    border-collapse: collapse;
}

.grade-table th {
    width: 20%;
}

.grade-table td,
.grade-table th {
    border: 2px solid navy;
    text-align: center;
}

/* Custom Button Styles for Profile Module Buttons */
.profile-btn {
    /* min-width: 100px; */
    /* Ensure all buttons are of similar width */
    /* border: 2px solid green; */
    /* font-weight: bold; */
    color: white !important;
    background-color: #4BB543;
    /* color: rgb(243, 180, 211); */
    /* text-decoration: underline; */
}

/* Hover effect */
/* .profile-btn:hover {
    background-color: rgb(188, 241, 188);
    color: black;
} */

/* Active Button Styles */
.active-button {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
}

/* Row Styling */
.v-row {
    width: 100%;
    justify-content: left;
    /* Align buttons to the left */
}

/* Custom Margin */
.mx-2 {
    margin-left: 10px;
    margin-right: 10px;
}
/* Sticky wrapper ensures sticky works */
.tabs-sticky-wrapper {
    position: relative;   /* required parent for sticky */
}

.sticky-tabs {
    position: sticky;
    top: 70px;
    z-index: auto;   /* 🔥 stop competing with dropdown */
}

/* Container */
.pill-container {
    padding: 24px;
    width: 100%;
}

.pill-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
}

.custom-tabs {
    background: white;
    border-radius: 32px;
    font-size: 14px;
    font-weight: 500;
    text-transform: none;
    color: #555;
    height: 52px;
    width: 160px;          /*  fixed equal size */
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 10px rgba(0,0,0,0.08);
}

.custom-tabs:hover {
    background-color: #f0f4ff;
    color: var(--v-brand-base);
    transform: translateY(-2px);
    border: 1px solid var(--v-brand-base);
}

.custom-tabs.active {
    background: color-mix(in srgb, var(--v-brand-base) 70%, white 30%);
    border: 1px solid var(--v-brand-base);
    color: #fff;
}

/* Responsive scroll */
@media (max-width: 600px) {
    .pill-wrapper {
        flex-wrap: nowrap;
        overflow-x: auto;
        padding-bottom: 4px;
    }
    .custom-tabs {
        flex: 0 0 auto;
    }
}
.tabs-outer {
    padding: 16px 20px 6px;   /* 🔥 top/bottom + left/right */
}

/* Divider line BELOW the card */
.tabs-outer::after {
    content: "";
    display: block;
    margin-top: 6px;      /* space AFTER the card */
    height: 1px;
    width: 100%;
    background: linear-gradient(
        to right,
        transparent,
        rgba(0, 0, 0, 0.15),
        transparent
    );
}

.tabs-bg {
    padding: 26px 24px;
    border-radius: 22px;
    width: 100%;
    min-height: 120px;

    /* Keep the soft white base but add a richer gradient */
    background-image:
        radial-gradient(
            circle at 28% 51%, 
            rgba(206, 206, 206,0.03) 0%, 
            rgba(206, 206, 206,0.03) 17%, 
            transparent 17%, 
            transparent 100%
        ),
        radial-gradient(
            circle at 45% 10%, 
            rgba(10, 10, 10,0.03) 0%, 
            rgba(10, 10, 10,0.03) 45%, 
            transparent 45%, 
            transparent 100%
        ),
        radial-gradient(
            circle at 48% 44%, 
            rgba(74, 74, 74,0.03) 0%, 
            rgba(74, 74, 74,0.03) 84%, 
            transparent 84%, 
            transparent 100%
        ),
        radial-gradient(
            circle at 47% 50%, 
            rgba(186, 186, 186,0.03) 0%, 
            rgba(186, 186, 186,0.03) 23%, 
            transparent 23%, 
            transparent 100%
        ),
        linear-gradient(145deg, #ffffff, #f5f5f7); /* subtle soft gradient */

    /* Soft shadows for depth and floating effect */
    box-shadow:
        0 12px 28px rgba(0,0,0,0.08),
        inset 0 1px 2px rgba(255,255,255,0.5);

    /* Smooth hover effect for cards inside */
    transition: all 0.3s ease;
}

/* When profile menu is open, disable stickiness */
body:has(.v-menu__content--active) .sticky-tabs {
    position: relative;
}
.active-btn {
  border-bottom: 3px solid #350096; /* blue underline */
  font-weight: 600;
}
.inactive-btn {
  color: #555;
}

.avg-hours-ui {
    /* 1. Dimensions: Fixed size so it matches both tabs */
    min-width: 200px;
    height: 150px;
    padding: 22px 24px;
    border-radius: 22px;

    /* 2. Colors & Style: High-end purple gradient */
    background: linear-gradient(135deg, #8B6FE8 0%, #A78BFA 50%, #C4B5FD 100%);
    box-shadow: 0 15px 30px rgba(139, 111, 232, 0.4), inset 0 0 0 1px rgba(255, 255, 255, 0.15);
    color: #ffffff;

    /* 3. Layout: Center text and value */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    text-align: center;
    
    /* 4. Animation for a smooth feel */
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

/* Title */
.avg-title {
    font-size: 15px;
    font-weight: 600;
    line-height: 1.2;
    text-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

/* Value */
.avg-value {
    font-size: 26px;
    font-weight: 800;
    text-shadow: 0 1px 4px rgba(0,0,0,0.25);
}

/* Filter card */
.filter-card {
  padding: 24px;
  border-radius: 18px;
  background: linear-gradient(135deg, #f8fafc, #eef2ff);
}

/* Fetch button */
.fetch-btn {
  margin-top: 0px;
  padding: 10px 26px;
  border-radius: 999px;
}

/* Wrapper */
.analytics-wrapper {
    display: flex;
    width: 100%;
    gap: 32px; /* Consistent gap between graph and card */
    align-items: center;
}

/* Chart card */
.chart-card {
  width: 100%;
  max-width: 1050px;
  padding: 20px;
  border-radius: 20px;
}


/* Container Grid for 2x2 Layout */
.stat-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    width: 100%;
    /* Removed height: 100% to allow vertical centering */
}

/* Individual Leave Card - Professional "Minor Light" Dark Look */
.leave-card {
    padding: 20px 10px;
    border-radius: 20px;
    text-align: center;
    color: white; 
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
    transition: transform 0.3s ease;
}

.leave-card:hover {
    transform: translateY(-5px);
}

.leave-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1px;
    margin-bottom: 8px;
    opacity: 0.95;
}

.leave-count {
    font-size: 32px;
    font-weight: 800;
}
.avg-performance-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 16px;
    padding: 24px;
    text-align: center;
    box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);
    width: 100%;
    max-width: 280px;
}

.avg-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
}

.avg-value {
    font-size: 48px;
    font-weight: 900;
    margin-bottom: 8px;
}

.avg-subtitle {
    font-size: 16px;
    opacity: 0.9;
}
/* Gradients using your requested colors (Minor Light version) */
.total-bg   { background: linear-gradient(135deg, #3b82f6 0%, #2563EB 100%); border: 1px solid rgba(255,255,255,0.2); }
.process-bg { background: linear-gradient(135deg, #fbbf24 0%, #F59E0B 100%); border: 1px solid rgba(255,255,255,0.2); }
.availed-bg { background: linear-gradient(135deg, #f87171 0%, #EF4444 100%); border: 1px solid rgba(255,255,255,0.2); }
.balance-bg { background: linear-gradient(135deg, #4ade80 0%, #22C55E 100%); border: 1px solid rgba(255,255,255,0.2); }

.chart-card-bg {
    background: #ffffff;
    border: 1px solid #e2e8f0 !important;
    border-radius: 24px;
}
.topic-scrollable-container {
  height: 650px;                  /* ← visible area height */
  width: 100%;
  max-width: 1400px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  background: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  margin: 0 auto;
}

.topic-scrollable-container::-webkit-scrollbar {
  width: 10px;
}
.topic-scrollable-container::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 10px;
}
.topic-scrollable-container::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 10px;
  border: 2px solid #f5f5f5;
}
.topic-scrollable-container::-webkit-scrollbar-thumb:hover {
  background: #a0a0a0;
}

.topic-chart-inner {
  width: 100%;
  height: 100%;
}
.leave-summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  max-width: 360px;
  margin: 0 auto;
}

.leave-square {
  padding: 18px 12px;
  border-radius: 12px;
  text-align: center;
  color: white;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 3px 10px rgba(0,0,0,0.12);
  transition: transform 0.2s;
}

.leave-square:hover {
  transform: translateY(-3px);
}

.leave-square .label {
  font-size: 0.95rem;
  font-weight: 600;
  opacity: 0.95;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.leave-square .value {
  font-size: 2.1rem;
  font-weight: 800;
}

.total       { background: linear-gradient(135deg, #3b82f6, #2563eb); }
.inprogress  { background: linear-gradient(135deg, #fbbf24, #f59e0b); }
.availed     { background: linear-gradient(135deg, #f87171, #ef4444); }
.balance     { background: linear-gradient(135deg, #4ade80, #22c55e); }

.chart-wrapper {
  transition: all 0.3s ease;
}
</style>
